import React, { useState, useEffect } from 'react';
import { Calendar, Clock, Shield, Users, LogOut, Plus, Trash2, Edit, Save, X, Key, Upload, Download ,Check} from 'lucide-react';
import { ref, set, onValue } from 'firebase/database';
import { database } from './firebase-config';

// ✅ YENİ - ÇOK KULLANICI
const ADMIN_USERS = [
  { username: 'abdullahabi', password: 'GOLDENLİGCKG' },
  { username: 'NAZLIM', password: 'GoldenLig06#' },
  { username: 'NONAME', password: 'EniyilerinLigi06#' }
];
const LEAGUES = [
  'Premier Lig Ankara',
  'Süper Lig Ankara Kapanış',
  '1.Lig Ankara',
  '2.Lig Ankara',
  '3.Lig Ankara',
  '4.Lig Ankara',
  '5.Lig Ankara'
];

const DAYS = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'];

const TIME_SLOTS: Record<string, Array<{time: string, field: string}>> = {
  'Pazartesi': [{ time: '19:15', field: 'Saha 1' }, { time: '20:15', field: 'Saha 1' }, { time: '21:15', field: 'Saha 1' }, { time: '22:15', field: 'Saha 1' }, { time: '23:15', field: 'Saha 1' }, { time: '00:15', field: 'Saha 1' }],
  'Salı': [{ time: '19:15', field: 'Saha 1' }, { time: '20:15', field: 'Saha 1' }, { time: '21:15', field: 'Saha 1' }, { time: '22:15', field: 'Saha 1' }, { time: '23:15', field: 'Saha 1' }, { time: '00:15', field: 'Saha 1' }],
  'Çarşamba': [{ time: '19:15', field: 'Saha 1' }, { time: '20:15', field: 'Saha 1' }, { time: '21:15', field: 'Saha 1' }, { time: '22:15', field: 'Saha 1' }, { time: '23:15', field: 'Saha 1' }, { time: '00:15', field: 'Saha 1' }],
  'Perşembe': [{ time: '19:15', field: 'Saha 1' }, { time: '20:15', field: 'Saha 1' }, { time: '21:15', field: 'Saha 1' }, { time: '22:15', field: 'Saha 1' }, { time: '23:15', field: 'Saha 1' }, { time: '00:15', field: 'Saha 1' }],
  'Cuma': [{ time: '19:15', field: 'Saha 1' }, { time: '20:15', field: 'Saha 1' }, { time: '21:15', field: 'Saha 1' }, { time: '22:15', field: 'Saha 1' }, { time: '23:15', field: 'Saha 1' }, { time: '00:15', field: 'Saha 1' }],
  'Cumartesi': [
    { time: '17:00', field: 'Saha 1' }, { time: '17:30', field: 'Saha 2' },
    { time: '18:00', field: 'Saha 1' }, { time: '18:30', field: 'Saha 2' },
    { time: '19:00', field: 'Saha 1' }, { time: '19:30', field: 'Saha 2' },
    { time: '20:00', field: 'Saha 1' }, { time: '20:30', field: 'Saha 2' },
    { time: '21:00', field: 'Saha 1' }, { time: '21:30', field: 'Saha 2' },
    { time: '22:30', field: 'Saha 2' },
    { time: '23:00', field: 'Saha 1' }, { time: '23:30', field: 'Saha 2' },
    { time: '00:00', field: 'Saha 1' }, { time: '00:30', field: 'Saha 2' },
    { time: '01:00', field: 'Saha 1' }, { time: '01:30', field: 'Saha 2' }
  ],
  'Pazar': [
    { time: '15:30', field: 'Saha 1' }, { time: '16:00', field: 'Saha 2' },
    { time: '16:30', field: 'Saha 1' }, { time: '17:00', field: 'Saha 2' },
    { time: '17:30', field: 'Saha 1' }, { time: '18:00', field: 'Saha 2' },
    { time: '18:30', field: 'Saha 1' }, { time: '19:00', field: 'Saha 2' },
    { time: '19:30', field: 'Saha 1' }, { time: '20:00', field: 'Saha 2' },
    { time: '20:30', field: 'Saha 1' }, { time: '21:00', field: 'Saha 2' },
    { time: '21:30', field: 'Saha 1' }, { time: '22:00', field: 'Saha 2' },
    { time: '22:30', field: 'Saha 1' }, { time: '23:00', field: 'Saha 2' },
    { time: '23:30', field: 'Saha 1' }, { time: '00:00', field: 'Saha 2' },
    { time: '00:30', field: 'Saha 1' }
  ]
};

interface Team {
  id: number;
  name: string;
  password: string;
  league: string;
}

interface Match {
  id: number;
  team1: string;
  team2: string;
  day?: string;
  time?: string;
  field?: string;
  week?: number;
  league?: string;
}
interface FixtureReport {
  totalMatches: number;
  placedMatches: number;
  perfectCount: number;
  commonDayCount: number;
  randomCount: number;
  details: FixtureReportItem[];
  createdAt: number;
}
interface Season {
  id: number;
  startDate: string; // "2025-01-01" formatında
  endDate: string;
  isActive: boolean;
  createdAt: number;
}

interface AvailabilitySlot {
  day: string;
  time: string;
  field: string;
  week: number;
}

interface WeekRange {
  weekNumber: number;
  startDate: string;
  endDate: string;
}
interface FixtureReportItem {
  team1: string;
  team2: string;
  week: number;
  day: string;
  time: string;
  status: 'perfect' | 'common-day' | 'random';
  message: string;
}
function createFixture(matches: Match[], availability: Record<string, AvailabilitySlot[]>, teams: Team[]): Match[] {
  const placed: Match[] = [];
  const usedSlots = new Set<string>();
  const teamLastMatch: Record<string, { day: string; week: number; time: string }> = {};
  const reportDetails: Array<{
    team1: string;
    team2: string;
    week: number;
    day: string;
    time: string;
    field: string;
    status: 'perfect' | 'common-day' | 'random';
    message: string;
  }> = [];

  const teamWeekDays: Record<string, string[]> = {};

  const getTeamWeekKey = (team: string, week: number) => `${team}-${week}`;

  const isTeamAvailableOnDay = (team: string, week: number, day: string): boolean => {
    const key = getTeamWeekKey(team, week);
    if (!teamWeekDays[key]) return true;
    
    const timesUsedThisDay = teamWeekDays[key].filter(d => d === day).length;
    if (timesUsedThisDay >= 1) return false;
    
    return true;
  };

  const markTeamDayUsed = (team: string, week: number, day: string) => {
    const key = getTeamWeekKey(team, week);
    if (!teamWeekDays[key]) {
      teamWeekDays[key] = [];
    }
    teamWeekDays[key].push(day);
  };

  const dayToNumber = (day: string): number => {
    const days = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'];
    return days.indexOf(day) + 1;
  };

  const daysDifferenceBetweenWeeks = (day1: string, week1: number, day2: string, week2: number): number => {
    const dayNum1 = dayToNumber(day1);
    const dayNum2 = dayToNumber(day2);
    
    if (week1 === week2) {
      return Math.abs(dayNum2 - dayNum1);
    }
    
    const weekDiff = week2 - week1;
    const totalDays = (weekDiff * 7) - dayNum1 + dayNum2;
    return totalDays;
  };

  const checkSlotFit = (
    team1: string,
    team2: string,
    day: string,
    time: string,
    field: string,
    week: number
  ): 'perfect' | 'common-day' | 'none' => {
    const team1Avail = (availability[team1] || []).filter(s => s.week === week);
    const team2Avail = (availability[team2] || []).filter(s => s.week === week);

    const team1HasSlot = team1Avail.some(s => s.day === day && s.time === time && s.field === field);
    const team2HasSlot = team2Avail.some(s => s.day === day && s.time === time && s.field === field);

    const team1Last = teamLastMatch[team1];
    const team2Last = teamLastMatch[team2];

    if (team1Last) {
      const diff = daysDifferenceBetweenWeeks(team1Last.day, team1Last.week, day, week);
      if (diff < 3) return 'none';
    }
    if (team2Last) {
      const diff = daysDifferenceBetweenWeeks(team2Last.day, team2Last.week, day, week);
      if (diff < 3) return 'none';
    }

    if (team1HasSlot && team2HasSlot) {
      return 'perfect';
    }

    const team1HasDay = team1Avail.some(s => s.day === day);
    const team2HasDay = team2Avail.some(s => s.day === day);

    if (team1HasDay && team2HasDay) {
      return 'common-day';
    }

    return 'none';
  };

  const weekSet = new Set<number>();
  matches.forEach(m => {
    if (m.week !== undefined) weekSet.add(m.week);
  });
  const weeks = Array.from(weekSet).sort((a, b) => a - b);

  console.log(`📅 Toplam ${weeks.length} hafta işlenecek`);

  for (const currentWeek of weeks) {
    console.log(`\n🏁 HAFTA ${currentWeek} İŞLENİYOR...`);

    const weekMatches = matches.filter(m => m.week === currentWeek);
    
    const matchesWithCommonSlots = weekMatches.map(match => {
      const team1Avail = (availability[match.team1] || []).filter(s => s.week === currentWeek);
      const team2Avail = (availability[match.team2] || []).filter(s => s.week === currentWeek);

      const commonSlots = team1Avail.filter(slot =>
        team2Avail.some(s => s.day === slot.day && s.time === slot.time && s.field === slot.field)
      );

      return { match, commonSlotCount: commonSlots.length };
    });

    const sortedWeekMatches = matchesWithCommonSlots.sort((a, b) => {
      const team1AMatches = weekMatches.filter(m =>
        m.team1 === a.match.team1 || m.team2 === a.match.team1 || 
        m.team1 === a.match.team2 || m.team2 === a.match.team2
      ).length;

      const team1BMatches = weekMatches.filter(m =>
        m.team1 === b.match.team1 || m.team2 === b.match.team1 || 
        m.team1 === b.match.team2 || m.team2 === b.match.team2
      ).length;

      if (team1AMatches !== team1BMatches) return team1BMatches - team1AMatches;

      if (a.commonSlotCount === 0 && b.commonSlotCount !== 0) return 1;
      if (a.commonSlotCount !== 0 && b.commonSlotCount === 0) return -1;
      return a.commonSlotCount - b.commonSlotCount;
    });

    const slotDemand: Record<string, number> = {};
    for (const { match } of sortedWeekMatches) {
      const team1Avail = (availability[match.team1] || []).filter(s => s.week === currentWeek);
      const team2Avail = (availability[match.team2] || []).filter(s => s.week === currentWeek);

      const commonSlots = team1Avail.filter(slot =>
        team2Avail.some(s => s.day === slot.day && s.time === slot.time && s.field === slot.field)
      );

      commonSlots.forEach(slot => {
        const key = `${slot.day}-${slot.time}-${slot.field}-${currentWeek}`;
        slotDemand[key] = (slotDemand[key] || 0) + 1;
      });
    }

    const weekPlaced: Match[] = [];
    const weekReportDetails: typeof reportDetails = [];

    for (const { match } of sortedWeekMatches) {
      const team1Avail = (availability[match.team1] || []).filter(s => s.week === currentWeek);
      const team2Avail = (availability[match.team2] || []).filter(s => s.week === currentWeek);

      let selectedSlot = null;
      let placementStatus: 'perfect' | 'common-day' | 'random' = 'random';
      let placementDay = '';

      let commonSlots = team1Avail.filter(slot =>
        team2Avail.some(s => s.day === slot.day && s.time === slot.time && s.field === slot.field)
      ).filter(slot => {
        const slotKey = `${slot.day}-${slot.time}-${slot.field}-${currentWeek}`;
        return !usedSlots.has(slotKey);
      });

      commonSlots = commonSlots.filter(slot => {
        const team1Last = teamLastMatch[match.team1];
        const team2Last = teamLastMatch[match.team2];

        if (team1Last) {
          const diff = daysDifferenceBetweenWeeks(team1Last.day, team1Last.week, slot.day, currentWeek);
          if (diff < 3) return false;
        }
        if (team2Last) {
          const diff = daysDifferenceBetweenWeeks(team2Last.day, team2Last.week, slot.day, currentWeek);
          if (diff < 3) return false;
        }
        return true;
      });

      commonSlots = commonSlots.filter(slot => {
        const team1Last = teamLastMatch[match.team1];
        const team2Last = teamLastMatch[match.team2];
        const isPrime = isPrimeTime(slot.time);

        if (team1Last && team1Last.week === currentWeek - 1) {
          const lastWasPrime = isPrimeTime(team1Last.time);
          if (!lastWasPrime && !isPrime) return false;
        }
        if (team2Last && team2Last.week === currentWeek - 1) {
          const lastWasPrime = isPrimeTime(team2Last.time);
          if (!lastWasPrime && !isPrime) return false;
        }
        return true;
      });

      commonSlots = commonSlots.filter(slot => {
        return isTeamAvailableOnDay(match.team1, currentWeek, slot.day) && 
               isTeamAvailableOnDay(match.team2, currentWeek, slot.day);
      });

      if (commonSlots.length > 0) {
        commonSlots.sort((a, b) => {
          const keyA = `${a.day}-${a.time}-${a.field}-${currentWeek}`;
          const keyB = `${b.day}-${b.time}-${b.field}-${currentWeek}`;
          return (slotDemand[keyA] || 0) - (slotDemand[keyB] || 0);
        });

        selectedSlot = commonSlots[0];
        placementStatus = 'perfect';
      }
      else {
        const team1Days = new Set(team1Avail.map(s => s.day));
        const team2Days = new Set(team2Avail.map(s => s.day));
        const commonDays = DAYS.filter(day => team1Days.has(day) && team2Days.has(day));

        if (commonDays.length > 0) {
          let found = false;

          for (const day of commonDays) {
            if (found) break;

            if (!isTeamAvailableOnDay(match.team1, currentWeek, day) || 
                !isTeamAvailableOnDay(match.team2, currentWeek, day)) {
              continue;
            }

            for (const slot of TIME_SLOTS[day]) {
              const slotKey = `${day}-${slot.time}-${slot.field}-${currentWeek}`;

              if (!usedSlots.has(slotKey)) {
                const team1Last = teamLastMatch[match.team1];
                const team2Last = teamLastMatch[match.team2];

                let validForTeam1 = true;
                let validForTeam2 = true;

                if (team1Last) {
                  const diff = daysDifferenceBetweenWeeks(team1Last.day, team1Last.week, day, currentWeek);
                  if (diff < 3) validForTeam1 = false;
                }
                if (team2Last) {
                  const diff = daysDifferenceBetweenWeeks(team2Last.day, team2Last.week, day, currentWeek);
                  if (diff < 3) validForTeam2 = false;
                }

                const isPrime = isPrimeTime(slot.time);

                if (team1Last && team1Last.week === currentWeek - 1) {
                  const lastWasPrime = isPrimeTime(team1Last.time);
                  if (!lastWasPrime && !isPrime) validForTeam1 = false;
                }
                if (team2Last && team2Last.week === currentWeek - 1) {
                  const lastWasPrime = isPrimeTime(team2Last.time);
                  if (!lastWasPrime && !isPrime) validForTeam2 = false;
                }

                if (validForTeam1 && validForTeam2) {
                  selectedSlot = { day, time: slot.time, field: slot.field, week: currentWeek };
                  placementStatus = 'common-day';
                  placementDay = day;
                  found = true;
                  break;
                }
              }
            }
          }
        }
      }

      if (!selectedSlot) {
        let found = false;

        for (const day of DAYS) {
          if (found) break;

          if (!isTeamAvailableOnDay(match.team1, currentWeek, day) || 
              !isTeamAvailableOnDay(match.team2, currentWeek, day)) {
            continue;
          }

          for (const slot of TIME_SLOTS[day]) {
            const slotKey = `${day}-${slot.time}-${slot.field}-${currentWeek}`;

            if (!usedSlots.has(slotKey)) {
              selectedSlot = { day, time: slot.time, field: slot.field, week: currentWeek };
              placementStatus = 'random';
              found = true;
              break;
            }
          }
        }
      }

      if (selectedSlot) {
        const slotKey = `${selectedSlot.day}-${selectedSlot.time}-${selectedSlot.field}-${currentWeek}`;

        const placedMatch = {
          ...match,
          day: selectedSlot.day,
          time: selectedSlot.time,
          field: selectedSlot.field,
          week: currentWeek
        };

        weekPlaced.push(placedMatch);
        usedSlots.add(slotKey);

        teamLastMatch[match.team1] = { day: selectedSlot.day, week: currentWeek, time: selectedSlot.time };
        teamLastMatch[match.team2] = { day: selectedSlot.day, week: currentWeek, time: selectedSlot.time };

        markTeamDayUsed(match.team1, currentWeek, selectedSlot.day);
        markTeamDayUsed(match.team2, currentWeek, selectedSlot.day);

        let message = '';
        if (placementStatus === 'perfect') {
          message = `✅ ${match.team1} vs ${match.team2} maçı, her iki takımın da müsait olduğu saate yerleştirildi.`;
        } else if (placementStatus === 'common-day') {
          message = `⚠️ ${match.team1} vs ${match.team2} maçı, istenilen saate yerleştirilemedi. Ortak gün olan ${selectedSlot.day}'a yerleştirildi.`;
        } else {
          message = `❌ ${match.team1} vs ${match.team2} maçı, istenilen saate yerleştirilemedi. Rastgele yerleştirilmek zorunda kalındı.`;
        }

        weekReportDetails.push({
          team1: match.team1,
          team2: match.team2,
          week: currentWeek,
          day: selectedSlot.day,
          time: selectedSlot.time,
          field: selectedSlot.field,
          status: placementStatus,
          message: message
        });
      } else {
        console.log(`❌ YERLEŞTİRİLEMEDİ: ${match.team1} vs ${match.team2} - Hafta ${currentWeek}`);
      }
    }

    // ============ BU HAFTANIN TAKASLARI ============
    console.log(`🔄 Hafta ${currentWeek} için TAKAS başlıyor...`);

    let weekSwapCount = 0;

    // 1. Random → Perfect/Common-Day Takas
    for (let i = 0; i < weekPlaced.length; i++) {
      if (weekReportDetails[i].status !== 'random') continue;

      const randomMatch = weekPlaced[i];

      for (let j = 0; j < weekPlaced.length; j++) {
        if (i === j || weekReportDetails[j].status === 'random') continue;

        const otherMatch = weekPlaced[j];

        const randomFitToOther = checkSlotFit(
          randomMatch.team1,
          randomMatch.team2,
          otherMatch.day!,
          otherMatch.time!,
          otherMatch.field!,
          currentWeek
        );

        const otherFitToRandom = checkSlotFit(
          otherMatch.team1,
          otherMatch.team2,
          randomMatch.day!,
          randomMatch.time!,
          randomMatch.field!,
          currentWeek
        );

        if (randomFitToOther !== 'none' && otherFitToRandom !== 'none') {
          const tempDay = weekPlaced[i].day;
          const tempTime = weekPlaced[i].time;
          const tempField = weekPlaced[i].field;

          weekPlaced[i].day = weekPlaced[j].day;
          weekPlaced[i].time = weekPlaced[j].time;
          weekPlaced[i].field = weekPlaced[j].field;

          weekPlaced[j].day = tempDay;
          weekPlaced[j].time = tempTime;
          weekPlaced[j].field = tempField;

          teamLastMatch[randomMatch.team1] = { day: weekPlaced[i].day!, week: currentWeek, time: weekPlaced[i].time! };
          teamLastMatch[randomMatch.team2] = { day: weekPlaced[i].day!, week: currentWeek, time: weekPlaced[i].time! };
          teamLastMatch[otherMatch.team1] = { day: weekPlaced[j].day!, week: currentWeek, time: weekPlaced[j].time! };
          teamLastMatch[otherMatch.team2] = { day: weekPlaced[j].day!, week: currentWeek, time: weekPlaced[j].time! };

          weekReportDetails[i].status = randomFitToOther;
          weekReportDetails[i].day = weekPlaced[i].day!;
          weekReportDetails[i].time = weekPlaced[i].time!;
          weekReportDetails[i].field = weekPlaced[i].field!;
          // ✅ MESAJ GÜNCELLE
          if (randomFitToOther === 'perfect') {
            weekReportDetails[i].message = `✅ ${weekPlaced[i].team1} vs ${weekPlaced[i].team2} maçı, her iki takımın da müsait olduğu saate yerleştirildi.`;
          } else {
            weekReportDetails[i].message = `⚠️ ${weekPlaced[i].team1} vs ${weekPlaced[i].team2} maçı, istenilen saate yerleştirilemedi. Ortak gün olan ${weekPlaced[i].day}'a yerleştirildi.`;
          }

          weekReportDetails[j].status = otherFitToRandom;
          weekReportDetails[j].day = weekPlaced[j].day!;
          weekReportDetails[j].time = weekPlaced[j].time!;
          weekReportDetails[j].field = weekPlaced[j].field!;
          // ✅ MESAJ GÜNCELLE
          if (otherFitToRandom === 'perfect') {
            weekReportDetails[j].message = `✅ ${weekPlaced[j].team1} vs ${weekPlaced[j].team2} maçı, her iki takımın da müsait olduğu saate yerleştirildi.`;
          } else {
            weekReportDetails[j].message = `⚠️ ${weekPlaced[j].team1} vs ${weekPlaced[j].team2} maçı, istenilen saate yerleştirilemedi. Ortak gün olan ${weekPlaced[j].day}'a yerleştirildi.`;
          }

          weekSwapCount++;
          break;
        }
      }
    }

    // 2. Common-Day → Perfect Takas
    for (let i = 0; i < weekPlaced.length; i++) {
      if (weekReportDetails[i].status !== 'common-day') continue;

      const commonMatch = weekPlaced[i];

      for (let j = 0; j < weekPlaced.length; j++) {
        if (i === j || weekReportDetails[j].status !== 'perfect') continue;

        const perfectMatch = weekPlaced[j];

        const commonFitToPerfect = checkSlotFit(
          commonMatch.team1,
          commonMatch.team2,
          perfectMatch.day!,
          perfectMatch.time!,
          perfectMatch.field!,
          currentWeek
        );

        const perfectFitToCommon = checkSlotFit(
          perfectMatch.team1,
          perfectMatch.team2,
          commonMatch.day!,
          commonMatch.time!,
          commonMatch.field!,
          currentWeek
        );

        if (commonFitToPerfect === 'perfect' && perfectFitToCommon === 'perfect') {
          const tempDay = weekPlaced[i].day;
          const tempTime = weekPlaced[i].time;
          const tempField = weekPlaced[i].field;

          weekPlaced[i].day = weekPlaced[j].day;
          weekPlaced[i].time = weekPlaced[j].time;
          weekPlaced[i].field = weekPlaced[j].field;

          weekPlaced[j].day = tempDay;
          weekPlaced[j].time = tempTime;
          weekPlaced[j].field = tempField;

          teamLastMatch[commonMatch.team1] = { day: weekPlaced[i].day!, week: currentWeek, time: weekPlaced[i].time! };
          teamLastMatch[commonMatch.team2] = { day: weekPlaced[i].day!, week: currentWeek, time: weekPlaced[i].time! };
          teamLastMatch[perfectMatch.team1] = { day: weekPlaced[j].day!, week: currentWeek, time: weekPlaced[j].time! };
          teamLastMatch[perfectMatch.team2] = { day: weekPlaced[j].day!, week: currentWeek, time: weekPlaced[j].time! };

          weekReportDetails[i].status = 'perfect';
          weekReportDetails[i].day = weekPlaced[i].day!;
          weekReportDetails[i].time = weekPlaced[i].time!;
          weekReportDetails[i].field = weekPlaced[i].field!;
          // ✅ MESAJ GÜNCELLE
          weekReportDetails[i].message = `✅ ${weekPlaced[i].team1} vs ${weekPlaced[i].team2} maçı, her iki takımın da müsait olduğu saate yerleştirildi.`;

          weekReportDetails[j].day = weekPlaced[j].day!;
          weekReportDetails[j].time = weekPlaced[j].time!;
          weekReportDetails[j].field = weekPlaced[j].field!;
          // ✅ MESAJ GÜNCELLE
          weekReportDetails[j].message = `✅ ${weekPlaced[j].team1} vs ${weekPlaced[j].team2} maçı, her iki takımın da müsait olduğu saate yerleştirildi.`;

          weekSwapCount++;
          break;
        }
      }
    }

    // 3. Common-Day ↔ Common-Day Takas
    for (let i = 0; i < weekPlaced.length; i++) {
      if (weekReportDetails[i].status !== 'common-day') continue;

      const match1 = weekPlaced[i];

      for (let j = i + 1; j < weekPlaced.length; j++) {
        if (weekReportDetails[j].status !== 'common-day') continue;

        const match2 = weekPlaced[j];

        const match1FitTo2 = checkSlotFit(
          match1.team1,
          match1.team2,
          match2.day!,
          match2.time!,
          match2.field!,
          currentWeek
        );

        const match2FitTo1 = checkSlotFit(
          match2.team1,
          match2.team2,
          match1.day!,
          match1.time!,
          match1.field!,
          currentWeek
        );

        if (match1FitTo2 === 'perfect' && match2FitTo1 === 'perfect') {
          const tempDay = weekPlaced[i].day;
          const tempTime = weekPlaced[i].time;
          const tempField = weekPlaced[i].field;

          weekPlaced[i].day = weekPlaced[j].day;
          weekPlaced[i].time = weekPlaced[j].time;
          weekPlaced[i].field = weekPlaced[j].field;

          weekPlaced[j].day = tempDay;
          weekPlaced[j].time = tempTime;
          weekPlaced[j].field = tempField;

          teamLastMatch[match1.team1] = { day: weekPlaced[i].day!, week: currentWeek, time: weekPlaced[i].time! };
          teamLastMatch[match1.team2] = { day: weekPlaced[i].day!, week: currentWeek, time: weekPlaced[i].time! };
          teamLastMatch[match2.team1] = { day: weekPlaced[j].day!, week: currentWeek, time: weekPlaced[j].time! };
          teamLastMatch[match2.team2] = { day: weekPlaced[j].day!, week: currentWeek, time: weekPlaced[j].time! };

          weekReportDetails[i].status = 'perfect';
          weekReportDetails[i].day = weekPlaced[i].day!;
          weekReportDetails[i].time = weekPlaced[i].time!;
          weekReportDetails[i].field = weekPlaced[i].field!;
          // ✅ MESAJ GÜNCELLE
          weekReportDetails[i].message = `✅ ${weekPlaced[i].team1} vs ${weekPlaced[i].team2} maçı, her iki takımın da müsait olduğu saate yerleştirildi.`;

          weekReportDetails[j].status = 'perfect';
          weekReportDetails[j].day = weekPlaced[j].day!;
          weekReportDetails[j].time = weekPlaced[j].time!;
          weekReportDetails[j].field = weekPlaced[j].field!;
          // ✅ MESAJ GÜNCELLE
          weekReportDetails[j].message = `✅ ${weekPlaced[j].team1} vs ${weekPlaced[j].team2} maçı, her iki takımın da müsait olduğu saate yerleştirildi.`;

          weekSwapCount++;
          break;
        }
      }
    }

    console.log(`✅ Hafta ${currentWeek}: ${weekSwapCount} takas yapıldı`);

    placed.push(...weekPlaced);
    reportDetails.push(...weekReportDetails);
  }

  const report: FixtureReport = {
    totalMatches: matches.length,
    placedMatches: placed.length,
    perfectCount: reportDetails.filter(r => r.status === 'perfect').length,
    commonDayCount: reportDetails.filter(r => r.status === 'common-day').length,
    randomCount: reportDetails.filter(r => r.status === 'random').length,
    details: reportDetails,
    createdAt: Date.now()
  };

  set(ref(database, 'fixture_report'), report).catch(err => {
    console.error('Rapor kaydedilemedi:', err);
  });

  console.log('📊 FİNAL FİKSTÜR RAPORU Firebase\'e kaydedildi:', report);

  return placed;
}
function getWeekRanges(seasonStartDate?: string): WeekRange[] {
  let startDate: Date;
  
  if (seasonStartDate) {
    // Admin tarafından belirlenen tarih
    startDate = new Date(seasonStartDate);
  } else {
    // Varsayılan: Bugünden sonraki Pazartesi
    const today = new Date();
    const currentDay = today.getDay();
    const daysUntilMonday = currentDay === 0 ? 1 : (8 - currentDay) % 7;
    startDate = new Date(today);
    startDate.setDate(today.getDate() + daysUntilMonday);
  }
  
  const weeks: WeekRange[] = [];
  for (let i = 0; i < 4; i++) {
    const weekStart = new Date(startDate);
    weekStart.setDate(startDate.getDate() + (i * 7));
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6);
    
    weeks.push({
      weekNumber: i + 1,
      startDate: weekStart.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' }),
      endDate: weekEnd.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })
    });
  }
  return weeks;
}

function isPrimeTime(time: string): boolean {
  const [hour] = time.split(':').map(Number);
  return hour >= 20 && hour < 24;
}

function App() {
  const [view, setView] = useState('login');
  const [userType, setUserType] = useState<string | null>(null);
  const [currentTeam, setCurrentTeam] = useState<Team | null>(null);
  const [teams, setTeams] = useState<Team[]>([]);
  const [fixtures, setFixtures] = useState<Match[]>([]);
  const [availability, setAvailability] = useState<Record<string, AvailabilitySlot[]>>({});
  const [fixturePublished, setFixturePublished] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    const teamsRef = ref(database, 'teams');
    const fixturesRef = ref(database, 'fixtures');
    const availRef = ref(database, 'availability');
    const publishedRef = ref(database, 'fixture_published');

    onValue(teamsRef, (snapshot) => {
      const data = snapshot.val();
      setTeams(data ? Object.values(data) : []);
    });

    onValue(fixturesRef, (snapshot) => {
      const data = snapshot.val();
      setFixtures(data ? Object.values(data) : []);
    });

    onValue(availRef, (snapshot) => {
      const data = snapshot.val();
      setAvailability(data || {});
    });

    onValue(publishedRef, (snapshot) => {
      setFixturePublished(snapshot.val() || false);
      setLoading(false);
    });
  };

  const saveTeams = async (newTeams: Team[]) => {
    try {
      const teamsObj = newTeams.reduce((acc, team) => {
        acc[team.id] = team;
        return acc;
      }, {} as Record<number, Team>);
      await set(ref(database, 'teams'), teamsObj);
    } catch (error) {
      alert('Kayıt hatası: ' + error);
    }
  };

  const saveFixtures = async (newFixtures: Match[]) => {
    try {
      const fixturesObj = newFixtures.reduce((acc, fixture) => {
        acc[fixture.id] = fixture;
        return acc;
      }, {} as Record<number, Match>);
      await set(ref(database, 'fixtures'), fixturesObj);
    } catch (error) {
      alert('Kayıt hatası: ' + error);
    }
  };

  const saveAvailability = async (newAvail: Record<string, AvailabilitySlot[]>) => {
    try {
      await set(ref(database, 'availability'), newAvail);
    } catch (error) {
      alert('Kayıt hatası: ' + error);
    }
  };

  const savePublished = async (status: boolean) => {
    try {
      await set(ref(database, 'fixture_published'), status);
    } catch (error) {
      alert('Kayıt hatası: ' + error);
    }
  };

  const logout = () => {
    setView('login');
    setUserType(null);
    setCurrentTeam(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-600 to-blue-700 flex items-center justify-center">
        <div className="text-white text-2xl">Yükleniyor...</div>
      </div>
    );
  }

  if (view === 'login') {
    return <LoginScreen setView={setView} setUserType={setUserType} setCurrentTeam={setCurrentTeam} teams={teams} />;
  }

  if (userType === 'admin') {
    return <AdminPanel view={view} setView={setView} logout={logout} teams={teams} saveTeams={saveTeams} fixtures={fixtures} saveFixtures={saveFixtures} availability={availability} fixturePublished={fixturePublished} savePublished={savePublished} />;
  }

  if (userType === 'captain') {
  return <CaptainPanel view={view} setView={setView} logout={logout} currentTeam={currentTeam!} fixtures={fixtures} availability={availability} saveAvailability={saveAvailability} fixturePublished={fixturePublished} teams={teams} saveTeams={saveTeams} />;
  }

  return null;
}

function LoginScreen({ setView, setUserType, setCurrentTeam, teams }: any) {
  const [loginType, setLoginType] = useState<string | null>(null);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [teamName, setTeamName] = useState('');
  const [error, setError] = useState('');

  const handleAdminLogin = () => {
    const validAdmin = ADMIN_USERS.find(
      admin => admin.username === username && admin.password === password
    );
    
    if (validAdmin) {
      setUserType('admin');
      setView('admin-menu');
    } else {
      setError('Kullanıcı adı veya şifre hatalı');
      setUsername('');
      setPassword('');
    }
  };

  const handleCaptainLogin = () => {
    const team = teams.find((t: Team) => t.name === teamName && t.password === password);
    if (team) {
      setUserType('captain');
      setCurrentTeam(team);
      setView('captain-menu');
    } else {
      setError('Takım adı veya şifre hatalı');
      setTeamName('');
      setPassword('');
    }
  };

  if (!loginType) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-600 to-blue-700 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-2xl overflow-hidden max-w-4xl w-full flex">
          {/* ✅ SOL TARAF - LOGO */}
          <div className="hidden md:flex md:w-1/2 bg-gradient-to-br from-green-500 to-blue-600 p-12 flex-col items-center justify-center">
            <img 
              src="/logo.png" 
              alt="Logo" 
              className="w-48 h-48 object-contain mb-6 drop-shadow-2xl"
            />
            <h2 className="text-3xl font-bold text-white text-center mb-4">
              Fikstür Yönetim Sistemi
            </h2>
            <p className="text-white/80 text-center text-lg">
              Profesyonel maç programlama ve takım yönetimi
            </p>
          </div>

          {/* SAĞ TARAF - GİRİŞ BUTONLARI */}
          <div className="w-full md:w-1/2 p-8">
            <div className="text-center mb-8">
              {/* Mobilde logo göster */}
              <div className="md:hidden mb-6">
                <img 
                  src="/logo.png" 
                  alt="Logo" 
                  className="w-24 h-24 mx-auto object-contain"
                />
              </div>
              <h1 className="text-3xl font-bold text-gray-800 mb-2">Hoş Geldiniz</h1>
              <p className="text-gray-600">Giriş türünü seçin</p>
            </div>
            <div className="space-y-4">
              <button 
                onClick={() => setLoginType('admin')} 
                className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-4 rounded-lg flex items-center justify-center gap-2 transition transform hover:scale-105"
              >
                <Shield size={24} />
                Admin Girişi
              </button>
              <button 
                onClick={() => setLoginType('captain')} 
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 rounded-lg flex items-center justify-center gap-2 transition transform hover:scale-105"
              >
                <Users size={24} />
                Kaptan Girişi
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-600 to-blue-700 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-2xl overflow-hidden max-w-4xl w-full flex">
        {/* ✅ SOL TARAF - LOGO */}
        <div className="hidden md:flex md:w-1/2 bg-gradient-to-br from-green-500 to-blue-600 p-12 flex-col items-center justify-center">
          <img 
            src="/logo.png" 
            alt="Logo" 
            className="w-48 h-48 object-contain mb-6 drop-shadow-2xl"
          />
          <h2 className="text-3xl font-bold text-white text-center mb-4">
            Fikstür Yönetim Sistemi
          </h2>
          <p className="text-white/80 text-center text-lg">
            {loginType === 'admin' ? 'Admin Paneli' : 'Takım Kaptanı Girişi'}
          </p>
        </div>

        {/* SAĞ TARAF - LOGIN FORMU */}
        <div className="w-full md:w-1/2 p-8">
          <button 
            onClick={() => { setLoginType(null); setError(''); }} 
            className="mb-4 text-gray-600 hover:text-gray-800 flex items-center gap-1 transition"
          >
            ← Geri
          </button>

          {/* Mobilde logo göster */}
          <div className="md:hidden text-center mb-6">
            <img 
              src="/logo.png" 
              alt="Logo" 
              className="w-20 h-20 mx-auto object-contain"
            />
          </div>

          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-gray-800 mb-2">
              {loginType === 'admin' ? '🔐 Admin Girişi' : '👤 Kaptan Girişi'}
            </h1>
          </div>

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
              {error}
            </div>
          )}

          <div className="space-y-4">
            {loginType === 'admin' ? (
              <>
                <input 
                  type="text" 
                  placeholder="Kullanıcı Adı" 
                  value={username} 
                  onChange={(e) => setUsername(e.target.value)} 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none transition" 
                />
                <input 
                  type="password" 
                  placeholder="Şifre" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none transition" 
                />
                <button 
                  onClick={handleAdminLogin} 
                  className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 rounded-lg transition transform hover:scale-105"
                >
                  Giriş Yap
                </button>
              </>
            ) : (
              <>
                <input 
                  type="text" 
                  placeholder="Takım Adı" 
                  value={teamName} 
                  onChange={(e) => setTeamName(e.target.value)} 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none transition" 
                />
                <input 
                  type="password" 
                  placeholder="Şifre" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none transition" 
                />
                <button 
                  onClick={handleCaptainLogin} 
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg transition transform hover:scale-105"
                >
                  Giriş Yap
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
// ✅ YENİ: Navbar Component
// ✅ YENİ: Navbar Component - "EN İYİLERİN LİGİ" ile
// Mevcut Navbar component'ini bununla değiştirin:
function Navbar() {
  return (
    <>
      {/* ÜST NAVBAR */}
      <div className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 shadow-lg border-b-4 border-yellow-500">
        <div className="max-w-full mx-auto px-8 py-4">
          <div className="flex items-center justify-between">
            {/* SOL TARAF - LOGO */}
            <div className="flex items-center gap-4">
              <img 
                src="/logo.png" 
                alt="Logo" 
                className="w-16 h-16 object-contain drop-shadow-xl"
              />
              <div>
                <h1 className="text-xl font-bold text-white">Fikstür Yönetim Sistemi</h1>
                <p className="text-sm text-gray-300">Profesyonel Maç Programlama</p>
              </div>
            </div>

            {/* ORTA - EN İYİLERİN LİGİ */}
            <div className="flex items-center gap-3 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 px-8 py-3 rounded-lg shadow-2xl transform hover:scale-105 transition-all duration-300 border-2 border-yellow-300">
              <div className="text-3xl animate-pulse">🏆</div>
              <div className="text-center">
                <div className="text-2xl font-black text-gray-900 tracking-wider" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>
                  EN İYİLERİN LİGİ
                </div>
              </div>
              <div className="text-3xl animate-pulse">⚽</div>
            </div>

            {/* SAĞ TARAF - İLETİŞİM */}
            <div className="text-right">
              <p className="text-base text-gray-200 font-semibold">İletişim</p>
              <div className="flex gap-3 mt-2 justify-end">
                {/* Instagram */}
                <a href="https://www.instagram.com/goldenleague_ankara?igsh=aGQ0emxocHN0OTFr" target="_blank" rel="noopener noreferrer" className="text-pink-400 hover:text-pink-300 transition">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                
                {/* Website */}
                <a href="https://www.goldenlig.com" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 transition">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm9.5 12c0 1.093-.195 2.141-.537 3.117l-4.464-12.234C18.51 4.123 19.937 6.827 21.5 12zm-9.5 9.5c-1.32 0-2.583-.27-3.731-.755l3.964-11.527 4.063 11.126c.027.067.058.13.092.191-1.363.641-2.884.965-4.388.965zm-8.407-3.102l3.842-11.141 3.964 10.87c-2.232 1.054-4.766 1.271-7.806.271zm-.593-5.398c0-1.544.372-3.001 1.029-4.285l4.556 12.476C4.428 19.434 3 16.918 3 12z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ALT FOOTER */}
      <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 border-t-2 border-yellow-500 shadow-lg z-50">
        <div className="max-w-full mx-auto px-8 py-3">
          <div className="flex items-center justify-between">
            {/* SOL - LOGO VE İSİM */}
            <div className="flex items-center gap-3">
              <img 
                src="/logo.png" 
                alt="Logo" 
                className="w-10 h-10 object-contain"
              />
              <div>
                <div className="text-white font-bold text-sm">GOLDEN LEAGUE</div>
                <div className="text-gray-400 text-xs">En İyilerin Ligi</div>
              </div>
            </div>

            {/* ORTA - COPYRIGHT */}
            <div className="text-center">
              <div className="text-gray-300 text-sm">
                © 2025 Golden League. Tüm hakları saklıdır.
              </div>
            </div>

            {/* SAĞ - SOSYAL MEDYA LİNKLERİ */}
            <div className="flex items-center gap-4">
              <span className="text-gray-400 text-sm">Bizi Takip Edin:</span>
              <div className="flex gap-3">
                {/* Instagram */}
                <a 
                  href="https://www.instagram.com/goldenleague_ankara?igsh=aGQ0emxocHN0OTFr" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-pink-600 hover:bg-pink-700 text-white p-2 rounded-full transition transform hover:scale-110"
                  title="Instagram"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                
                {/* Website */}
                <a 
                  href="https://www.goldenlig.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-blue-600 hover:bg-blue-700 text-white p-2 rounded-full transition transform hover:scale-110"
                  title="Website"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm9.5 12c0 1.093-.195 2.141-.537 3.117l-4.464-12.234C18.51 4.123 19.937 6.827 21.5 12zm-9.5 9.5c-1.32 0-2.583-.27-3.731-.755l3.964-11.527 4.063 11.126c.027.067.058.13.092.191-1.363.641-2.884.965-4.388.965zm-8.407-3.102l3.842-11.141 3.964 10.87c-2.232 1.054-4.766 1.271-7.806.271zm-.593-5.398c0-1.544.372-3.001 1.029-4.285l4.556 12.476C4.428 19.434 3 16.918 3 12z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function AdminPanel({ view, setView, logout, teams, saveTeams, fixtures, saveFixtures, availability, fixturePublished, savePublished }: any) {
  const [pendingMatches, setPendingMatches] = useState<Match[]>([]);
  if (view === 'admin-menu') {
    return (
      <div className="min-h-screen bg-gray-100 p-4">
         <Navbar />
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-lg p-6 mb-4">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-2xl font-bold text-gray-800">🔐 Admin Paneli</h1>
              <button onClick={logout} className="flex items-center gap-2 text-red-600 hover:text-red-700">
                <LogOut size={20} /> Çıkış
              </button>
            </div>
            
            {/* ✅ TEK BİR GRID - DÜZELTİLMİŞ */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <button onClick={() => setView('view-fixture')} className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-6 rounded-lg flex items-center justify-center gap-2 transition">
                <Calendar size={24} />
                Fikstürü Gör
              </button>
              
              <button onClick={() => setView('view-availability')} className="bg-teal-600 hover:bg-teal-700 text-white font-semibold py-6 rounded-lg flex items-center justify-center gap-2 transition">
                <Clock size={24} />
                Müsaitleri Gör
              </button>
              
              <button onClick={() => setView('upload-excel')} className="bg-green-600 hover:bg-green-700 text-white font-semibold py-6 rounded-lg flex items-center justify-center gap-2 transition">
                <Upload size={24} />
                Eşleşme Ekle
              </button>
              
              <button onClick={() => setView('reset-fixture')} className="bg-orange-600 hover:bg-orange-700 text-white font-semibold py-6 rounded-lg flex items-center justify-center gap-2 transition">
                <Trash2 size={24} />
                Fikstürü Sıfırla
              </button>
              
              <button onClick={() => setView('team-management')} className="bg-purple-600 hover:bg-purple-700 text-white font-semibold py-6 rounded-lg flex items-center justify-center gap-2 transition">
                <Users size={24} />
                Takım Yönetimi
              </button>
              <button onClick={() => setView('search-availability')} className="bg-purple-600 hover:bg-purple-700 text-white font-semibold py-6 rounded-lg flex items-center justify-center gap-2 transition">
  🔍 Müsaitlik Ara
</button>
              <button onClick={() => setView('season-management')} className="bg-yellow-600 hover:bg-yellow-700 text-white font-semibold py-6 rounded-lg flex items-center justify-center gap-2 transition">
                <Calendar size={24} />
                Dönem Yönetimi
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

if (view === 'view-fixture') {
  return  (
  <>
   <Navbar />
  <AdminViewFixture 
    setView={setView} 
    fixtures={fixtures} 
    saveFixtures={saveFixtures} 
    teams={teams} 
    fixturePublished={fixturePublished} 
    savePublished={savePublished}
    availability={availability}  // ✅ YENİ: Eklendi
  />
  </>);
}

  if (view === 'upload-excel') {
    return (
      <>
     <Navbar />
   <AdminUploadExcel setView={setView} teams={teams} />;
   </>);
  }

  if (view === 'view-availability') {
    return (
      <>
     <Navbar />
     <AdminViewAvailability setView={setView} teams={teams} availability={availability} />;
     </>);
  }

  if (view === 'review-matches') {
    return (
      <>
     <Navbar />
     <ReviewMatches setView={setView} teams={teams} availability={availability} saveFixtures={saveFixtures} />;
     </>);
  }

  if (view === 'reset-fixture') {
    return (
      <>
     <Navbar />
     <AdminResetFixture setView={setView} saveFixtures={saveFixtures} savePublished={savePublished} />;
     </>);
  }
if (view === 'search-availability') {
  return (
    <>
   <Navbar />
   <SearchAvailability setView={setView} teams={teams} availability={availability} />;
   </>);
}
  if (view === 'team-management') {
    return (
      <>
     <Navbar />
     <TeamManagement setView={setView} teams={teams} saveTeams={saveTeams} />;
     </>);
  }

  if (view === 'season-management') {
    return (
     <>
     <Navbar />
     <SeasonManagement setView={setView} />;
     </>);
  }
  
  return null;
}

function AdminViewFixture({ setView, fixtures, saveFixtures, teams, fixturePublished, savePublished, availability }: any) {
  const [selectedWeek, setSelectedWeek] = useState(1);
  const [selectedLeague, setSelectedLeague] = useState('Tümü');
  const [editingMatch, setEditingMatch] = useState<Match | null>(null);
  const [showReport, setShowReport] = useState(false);
  const [fixtureReport, setFixtureReport] = useState<FixtureReport | null>(null);

  useEffect(() => {
    const reportRef = ref(database, 'fixture_report');
    onValue(reportRef, (snapshot) => {
      setFixtureReport(snapshot.val());
    });
  }, []);

  const filteredFixtures = fixtures.filter((f: Match) => {
    const weekMatch = f.week === selectedWeek;
    const leagueMatch = selectedLeague === 'Tümü' || f.league === selectedLeague;
    return weekMatch && leagueMatch;
  });

  const handlePublish = () => {
    if (window.confirm('Fikstürü yayınlamak istediğinizden emin misiniz?')) {
      savePublished(true);
      alert('Fikstür yayınlandı!');
    }
  };

  const handleEdit = (match: Match) => {
    setEditingMatch({ ...match });
  };

  const dayToNumber = (day: string): number => {
    const days = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'];
    return days.indexOf(day) + 1;
  };

  const daysDifferenceBetweenWeeks = (day1: string, week1: number, day2: string, week2: number): number => {
    const dayNum1 = dayToNumber(day1);
    const dayNum2 = dayToNumber(day2);
    
    if (week1 === week2) {
      return Math.abs(dayNum2 - dayNum1);
    }
    
    const weekDiff = week2 - week1;
    const totalDays = (weekDiff * 7) - dayNum1 + dayNum2;
    return totalDays;
  };

  const getTeamOtherMatches = (teamName: string, excludeMatchId: number): Match[] => {
    return fixtures.filter((f: Match) => 
      f.id !== excludeMatchId && (f.team1 === teamName || f.team2 === teamName)
    );
  };

  const validateManualEdit = (match: Match): { isValid: boolean, warnings: string[] } => {
    const warnings: string[] = [];
    
    if (!match.day || !match.time || !match.week) {
      return { isValid: false, warnings: ['Gün, saat ve hafta bilgisi eksik!'] };
    }

    const team1Avail = (availability[match.team1] || []).filter((s: AvailabilitySlot) => s.week === match.week);
    const team2Avail = (availability[match.team2] || []).filter((s: AvailabilitySlot) => s.week === match.week);

    const team1HasSlot = team1Avail.some((s: AvailabilitySlot) => 
      s.day === match.day && s.time === match.time && s.field === match.field
    );
    const team2HasSlot = team2Avail.some((s: AvailabilitySlot) => 
      s.day === match.day && s.time === match.time && s.field === match.field
    );

    if (!team1HasSlot) {
      warnings.push(`⚠️ ${match.team1} bu saati müsait olarak işaretlememiş!`);
    }
    if (!team2HasSlot) {
      warnings.push(`⚠️ ${match.team2} bu saati müsait olarak işaretlememiş!`);
    }

    const team1OtherMatches = getTeamOtherMatches(match.team1, match.id);
    const team2OtherMatches = getTeamOtherMatches(match.team2, match.id);

    for (const otherMatch of team1OtherMatches) {
      if (otherMatch.day && otherMatch.week !== undefined) {
        const diff = daysDifferenceBetweenWeeks(otherMatch.day, otherMatch.week, match.day, match.week);
        if (diff < 3) {
          warnings.push(`⚠️ ${match.team1} takımının ${otherMatch.week}. haftadaki ${otherMatch.day} maçıyla arası ${diff} gün! (Minimum 3 gün olmalı)`);
        }
      }
    }

    for (const otherMatch of team2OtherMatches) {
      if (otherMatch.day && otherMatch.week !== undefined) {
        const diff = daysDifferenceBetweenWeeks(otherMatch.day, otherMatch.week, match.day, match.week);
        if (diff < 3) {
          warnings.push(`⚠️ ${match.team2} takımının ${otherMatch.week}. haftadaki ${otherMatch.day} maçıyla arası ${diff} gün! (Minimum 3 gün olmalı)`);
        }
      }
    }

    const team1SameWeekMatches = team1OtherMatches.filter(m => m.week === match.week && m.day === match.day);
    const team2SameWeekMatches = team2OtherMatches.filter(m => m.week === match.week && m.day === match.day);

    if (team1SameWeekMatches.length > 0) {
      warnings.push(`❌ ${match.team1} takımının aynı haftada aynı günde başka maçı var!`);
    }
    if (team2SameWeekMatches.length > 0) {
      warnings.push(`❌ ${match.team2} takımının aynı haftada aynı günde başka maçı var!`);
    }

    return { isValid: warnings.length === 0, warnings };
  };

  const handleSaveEdit = () => {
    if (!editingMatch) return;

    const validation = validateManualEdit(editingMatch);
    
    if (validation.warnings.length > 0) {
      const warningMessage = 'UYARILAR:\n\n' + validation.warnings.join('\n\n') + '\n\nYine de kaydetmek istiyor musunuz?';
      if (!window.confirm(warningMessage)) {
        return;
      }
    }

    const updated = fixtures.map((f: Match) => f.id === editingMatch.id ? editingMatch : f);
    saveFixtures(updated);
    setEditingMatch(null);
    alert('Maç güncellendi!');
  };

  const handleDelete = (matchId: number) => {
    if (window.confirm('Bu maçı silmek istediğinizden emin misiniz?')) {
      const updated = fixtures.filter((f: Match) => f.id !== matchId);
      saveFixtures(updated);
    }
  };

  const downloadExcel = async () => {
    try {
      const XLSX = await import('xlsx');
      
      const dayOrder: Record<string, number> = {
        'Pazartesi': 1,
        'Salı': 2,
        'Çarşamba': 3,
        'Perşembe': 4,
        'Cuma': 5,
        'Cumartesi': 6,
        'Pazar': 7
      };
      
      const sortedFixtures = [...filteredFixtures].sort((a, b) => {
        const dayDiff = dayOrder[a.day!] - dayOrder[b.day!];
        if (dayDiff !== 0) return dayDiff;
        
        const timeA = a.time || '00:00';
        const timeB = b.time || '00:00';
        return timeA.localeCompare(timeB);
      });
      
      const data = sortedFixtures.map((m: Match) => ({
        'Hafta': m.week,
        'Lig': m.league,
        'Takım 1': m.team1,
        'Takım 2': m.team2,
        'Gün': m.day,
        'Saat': m.time,
        'Saha': m.field
      }));

      const ws = XLSX.utils.json_to_sheet(data);
      
      ws['!cols'] = [
        { wch: 8 },
        { wch: 30 },
        { wch: 25 },
        { wch: 25 },
        { wch: 12 },
        { wch: 8 },
        { wch: 8 }
      ];
      
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Fikstür');
      
      const fileName = selectedLeague === 'Tümü' 
        ? `Tum_Ligler_Hafta_${selectedWeek}.xlsx`
        : `${selectedLeague}_Hafta_${selectedWeek}.xlsx`;
      
      XLSX.writeFile(wb, fileName);
    } catch (err) {
      alert('Excel indirme hatası: ' + err);
    }
  };

  const reportData = fixtureReport;

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">📅 Fikstürü Gör</h1>
            <button onClick={() => setView('admin-menu')} className="text-gray-600 hover:text-gray-800">← Geri</button>
          </div>

          {!fixturePublished && fixtures.length > 0 && (
            <div className="mb-4 flex gap-2 flex-wrap">
              <button onClick={handlePublish} className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-6 rounded-lg">
                Fikstürü Yayınla
              </button>
              {reportData && (
                <button 
                  onClick={() => setShowReport(!showReport)} 
                  className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg flex items-center gap-2"
                >
                  📊 Eşleşme Raporu {showReport ? '▲' : '▼'}
                </button>
              )}
            </div>
          )}

          {showReport && reportData && (
            <div className="mb-6 border-2 border-blue-300 rounded-lg p-4 bg-blue-50">
              <h2 className="text-xl font-bold text-blue-900 mb-4">📊 Eşleşme Raporu</h2>
              
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                <div className="bg-white rounded-lg p-4 border-2 border-gray-300">
                  <div className="text-sm text-gray-600 mb-1">Toplam Maç</div>
                  <div className="text-3xl font-bold text-gray-800">{reportData.totalMatches}</div>
                </div>
                
                <div className="bg-white rounded-lg p-4 border-2 border-green-400">
                  <div className="text-sm text-gray-600 mb-1">✅ Mükemmel Yerleşen</div>
                  <div className="text-3xl font-bold text-green-600">{reportData.perfectCount}</div>
                </div>
                
                <div className="bg-white rounded-lg p-4 border-2 border-yellow-400">
                  <div className="text-sm text-gray-600 mb-1">⚠️ Ortak Güne Yerleşen</div>
                  <div className="text-3xl font-bold text-yellow-600">{reportData.commonDayCount}</div>
                </div>

                <div className="bg-white rounded-lg p-4 border-2 border-red-400">
                  <div className="text-sm text-gray-600 mb-1">❌ Rastgele Yerleşen</div>
                  <div className="text-3xl font-bold text-red-600">{reportData.randomCount}</div>
                </div>
              </div>

              <div className="bg-white rounded-lg p-4 border-2 border-blue-300 max-h-96 overflow-y-auto">
                <h3 className="font-bold text-blue-900 mb-3">Detaylı Rapor</h3>
                <div className="space-y-2">
                  {reportData.details
                    .filter((d: any) => d.status !== 'perfect')
                    .map((detail: any, idx: number) => (
                      <div 
                        key={idx} 
                        className={`p-3 rounded-lg border ${
                          detail.status === 'common-day' 
                            ? 'bg-yellow-50 border-yellow-300' 
                            : 'bg-red-50 border-red-300'
                        }`}
                      >
                        <div className="font-medium">{detail.message}</div>
                        <div className="text-sm text-gray-600 mt-1">
                          {detail.week}. Hafta | {detail.day} {detail.time} | {detail.field}
                        </div>
                      </div>
                    ))}
                  {reportData.details.filter((d: any) => d.status !== 'perfect').length === 0 && (
                    <div className="text-center py-4 text-green-600 font-bold">
                      🎉 Tüm maçlar mükemmel şekilde yerleştirildi!
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {fixturePublished && (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-2 rounded mb-4">
              ✓ Fikstür yayınlanmış
            </div>
          )}

          <div className="mb-6 space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Hafta Seç:</label>
              <div className="flex gap-2">
                {[1, 2, 3, 4].map(week => (
                  <button 
                    key={week} 
                    onClick={() => setSelectedWeek(week)} 
                    className={`px-4 py-2 rounded-lg font-semibold transition ${selectedWeek === week ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                  >
                    {week}. Hafta
                  </button>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Lig Filtrele:</label>
              <select 
                value={selectedLeague} 
                onChange={(e) => setSelectedLeague(e.target.value)} 
                className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              >
                <option value="Tümü">Tüm Ligler</option>
                {LEAGUES.map(league => <option key={league} value={league}>{league}</option>)}
              </select>
            </div>

            <button 
              onClick={downloadExcel} 
              className="bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-6 rounded-lg flex items-center gap-2"
            >
              <Download size={20} />
              Excel İndir ({selectedLeague} - {selectedWeek}. Hafta)
            </button>
          </div>

          {fixtures.length === 0 ? (
            <div className="text-center py-12 text-gray-500">
              Henüz fikstür hazırlanmamış
            </div>
          ) : filteredFixtures.length === 0 ? (
            <div className="text-center py-12 text-gray-500">
              {selectedLeague} - {selectedWeek}. hafta için maç yok
            </div>
          ) : (
            <div className="space-y-3">
              {filteredFixtures.map((match: Match) => (
                <div key={match.id} className="border border-gray-300 rounded-lg p-4 hover:shadow-md transition">
                  {editingMatch && editingMatch.id === match.id ? (
                    <div className="space-y-3">
                      <div className="grid grid-cols-2 gap-2">
                        <select value={editingMatch.team1} onChange={(e) => setEditingMatch({ ...editingMatch, team1: e.target.value })} className="px-3 py-2 border rounded">
                          {teams.map((t: Team) => <option key={t.id} value={t.name}>{t.name}</option>)}
                        </select>
                        <select value={editingMatch.team2} onChange={(e) => setEditingMatch({ ...editingMatch, team2: e.target.value })} className="px-3 py-2 border rounded">
                          {teams.map((t: Team) => <option key={t.id} value={t.name}>{t.name}</option>)}
                        </select>
                      </div>
                      <div className="grid grid-cols-4 gap-2">
                        <select value={editingMatch.week} onChange={(e) => setEditingMatch({ ...editingMatch, week: parseInt(e.target.value) })} className="px-3 py-2 border rounded">
                          <option value={1}>1. Hafta</option>
                          <option value={2}>2. Hafta</option>
                          <option value={3}>3. Hafta</option>
                          <option value={4}>4. Hafta</option>
                        </select>
                        <select value={editingMatch.day} onChange={(e) => setEditingMatch({ ...editingMatch, day: e.target.value })} className="px-3 py-2 border rounded">
                          {DAYS.map(d => <option key={d} value={d}>{d}</option>)}
                        </select>
                        <input type="text" value={editingMatch.time} onChange={(e) => setEditingMatch({ ...editingMatch, time: e.target.value })} className="px-3 py-2 border rounded" placeholder="Saat (HH:MM)" />
                        <select value={editingMatch.field} onChange={(e) => setEditingMatch({ ...editingMatch, field: e.target.value })} className="px-3 py-2 border rounded">
                          <option value="Saha 1">Saha 1</option>
                          <option value="Saha 2">Saha 2</option>
                        </select>
                      </div>
                      <div className="flex gap-2">
                        <button onClick={handleSaveEdit} className="flex items-center gap-1 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">
                          <Save size={16} /> Kaydet
                        </button>
                        <button onClick={() => setEditingMatch(null)} className="flex items-center gap-1 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600">
                          <X size={16} /> İptal
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="flex justify-between items-center">
                      <div className="flex-1">
                        <div className="text-xs text-gray-500 mb-1">{match.league}</div>
                        <div className="font-bold text-lg text-gray-800">{match.team1} vs {match.team2}</div>
                        <div className="text-gray-600">{match.day} - {match.time} - {match.field}</div>
                      </div>
                      <div className="flex gap-2">
                        <button onClick={() => handleEdit(match)} className="text-blue-600 hover:text-blue-700">
                          <Edit size={20} />
                        </button>
                        <button onClick={() => handleDelete(match.id)} className="text-red-600 hover:text-red-700">
                          <Trash2 size={20} />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function AdminCreateFixture({ setView, teams, saveFixtures, availability }: any) {
  const [matches, setMatches] = useState<Match[]>([]);
  const [team1, setTeam1] = useState('');
  const [team2, setTeam2] = useState('');
  const [error, setError] = useState('');

  const addMatch = () => {
    setError('');
    if (!team1 || !team2) {
      setError('Her iki takımı da seçin');
      return;
    }
    if (team1 === team2) {
      setError('Aynı takımı seçemezsiniz');
      return;
    }
    if (matches.some(m => m.team1 === team1 || m.team2 === team1)) {
      setError(team1 + ' zaten eşleştirilmiş');
      return;
    }
    if (matches.some(m => m.team1 === team2 || m.team2 === team2)) {
      setError(team2 + ' zaten eşleştirilmiş');
      return;
    }
    setMatches([...matches, { id: Date.now(), team1, team2 }]);
    setTeam1('');
    setTeam2('');
  };

  const removeMatch = (id: number) => {
    setMatches(matches.filter(m => m.id !== id));
  };

  const autoPlaceMatches = () => {
    if (matches.length === 0) {
      alert('Önce eşleştirme yapın');
      return;
    }

    const placed: Match[] = [];
    const notPlaced: Match[] = [];
    const usedSlots = new Set();

    for (const match of matches) {
      const team1Avail: AvailabilitySlot[] = availability[match.team1] || [];
      const team2Avail: AvailabilitySlot[] = availability[match.team2] || [];
      const commonSlots = team1Avail.filter(slot => 
        team2Avail.some(s => s.day === slot.day && s.time === slot.time && s.field === slot.field)
      ).filter(slot => !usedSlots.has(`${slot.day}-${slot.time}-${slot.field}`));

      if (commonSlots.length > 0) {
        const selected = commonSlots[0];
        placed.push({ ...match, day: selected.day, time: selected.time, field: selected.field });
        usedSlots.add(`${selected.day}-${selected.time}-${selected.field}`);
      } else {
        notPlaced.push(match);
      }
    }

    for (const match of notPlaced) {
      let found = false;
      for (const day of DAYS) {
        for (const slot of TIME_SLOTS[day]) {
          const key = `${day}-${slot.time}-${slot.field}`;
          if (!usedSlots.has(key)) {
            placed.push({ ...match, day, time: slot.time, field: slot.field });
            usedSlots.add(key);
            found = true;
            break;
          }
        }
        if (found) break;
      }
    }

    saveFixtures(placed);
    alert('Fikstür hazırlandı!');
    setView('admin-menu');
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">⚽ Fikstür Hazırla</h1>
            <button onClick={() => setView('admin-menu')} className="text-gray-600 hover:text-gray-800">← Geri</button>
          </div>

          {error && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">{error}</div>}

          <div className="mb-6 p-4 bg-gray-50 rounded-lg">
            <h2 className="font-bold mb-3 text-gray-700">Yeni Eşleştirme Ekle</h2>
            <div className="grid grid-cols-2 gap-3 mb-3">
              <select value={team1} onChange={(e) => setTeam1(e.target.value)} className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none">
                <option value="">Takım 1 Seç</option>
                {teams.map((t: Team) => <option key={t.id} value={t.name}>{t.name}</option>)}
              </select>
              <select value={team2} onChange={(e) => setTeam2(e.target.value)} className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none">
                <option value="">Takım 2 Seç</option>
                {teams.map((t: Team) => <option key={t.id} value={t.name}>{t.name}</option>)}
              </select>
            </div>
            <button onClick={addMatch} className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg flex items-center gap-2">
              <Plus size={20} /> Ekle
            </button>
          </div>

          {matches.length > 0 && (
            <>
              <div className="mb-6">
                <h2 className="font-bold mb-3 text-gray-700">Eşleştirmeler ({matches.length})</h2>
                <div className="space-y-2">
                  {matches.map((match: Match) => (
                    <div key={match.id} className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                      <span className="font-medium">{match.team1} vs {match.team2}</span>
                      <button onClick={() => removeMatch(match.id)} className="text-red-600 hover:text-red-700">
                        <Trash2 size={20} />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
              <button onClick={autoPlaceMatches} className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-lg">
                Saatleri Otomatik Yerleştir
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function AdminResetFixture({ setView, saveFixtures, savePublished }: any) {
  const handleReset = () => {
    if (window.confirm('Fikstürü sıfırlamak istediğinizden emin misiniz? Bu işlem geri alınamaz.')) {
      saveFixtures([]);
      savePublished(false);
      alert('Fikstür sıfırlandı!');
      setView('admin-menu');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">⚠️ Fikstürü Sıfırla</h1>
            <button onClick={() => setView('admin-menu')} className="text-gray-600 hover:text-gray-800">← Geri</button>
          </div>
          <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded mb-6">
            <p className="font-bold mb-2">Dikkat!</p>
            <p>Bu işlem tüm fikstürü silecektir. Bu işlem geri alınamaz.</p>
          </div>
          <button onClick={handleReset} className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 rounded-lg">
            Fikstürü Sıfırla
          </button>
        </div>
      </div>
    </div>
  );
}
function AdminUploadExcel({ setView, teams }: any) {
  const [error, setError] = useState('');
  const [pendingMatches, setPendingMatches] = useState<Match[]>([]);
  
  // ✅ YENİ: Manuel ekleme için state'ler
  const [newTeam1, setNewTeam1] = useState('');
  const [newTeam2, setNewTeam2] = useState('');
  const [newWeek, setNewWeek] = useState(1);

const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
  const file = e.target.files?.[0];
  if (!file) return;

  setError('');

  try {
    const XLSX = await import('xlsx');
    const reader = new FileReader();
    
    reader.onload = (event) => {
      try {
        const data = new Uint8Array(event.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData: any[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        const newMatches: Match[] = [];
        const conflicts: string[] = [];
        const notFoundTeams: string[] = []; // ✅ YENİ: Bulunamayan takımlar
        const skippedMatches: string[] = []; // ✅ YENİ: Atlanan maçlar

        for (let i = 1; i < jsonData.length; i++) {
          const row = jsonData[i];
          if (!row[0] || !row[1] || !row[2]) continue;

          const team1Name = String(row[0]).trim();
          const team2Name = String(row[1]).trim();
          const week = parseInt(String(row[2]).trim());
          
          // ✅ KONTROL 1: Hafta geçerli mi?
          if (week < 1 || week > 4) {
            skippedMatches.push(`Satır ${i + 1}: ${team1Name} vs ${team2Name} (Geçersiz hafta: ${week})`);
            continue;
          }

          // ✅ KONTROL 2: Takımlar sistemde var mı?
          const team1 = teams.find((t: Team) => t.name === team1Name);
          const team2 = teams.find((t: Team) => t.name === team2Name);

          if (!team1) {
            if (!notFoundTeams.includes(team1Name)) {
              notFoundTeams.push(team1Name);
            }
            skippedMatches.push(`Satır ${i + 1}: ${team1Name} vs ${team2Name} (${team1Name} bulunamadı)`);
            continue;
          }

          if (!team2) {
            if (!notFoundTeams.includes(team2Name)) {
              notFoundTeams.push(team2Name);
            }
            skippedMatches.push(`Satır ${i + 1}: ${team1Name} vs ${team2Name} (${team2Name} bulunamadı)`);
            continue;
          }

          // ✅ KONTROL 3: Bu takımlar bu haftada zaten mevcut maçlarda var mı?
          const team1Conflict = pendingMatches.some(m => 
            m.week === week && (m.team1 === team1Name || m.team2 === team1Name)
          );
          const team2Conflict = pendingMatches.some(m => 
            m.week === week && (m.team1 === team2Name || m.team2 === team2Name)
          );

          if (team1Conflict) {
            conflicts.push(`${team1Name} - ${week}. hafta`);
            skippedMatches.push(`Satır ${i + 1}: ${team1Name} vs ${team2Name} (${team1Name} zaten bu haftada maç var)`);
            continue;
          }
          if (team2Conflict) {
            conflicts.push(`${team2Name} - ${week}. hafta`);
            skippedMatches.push(`Satır ${i + 1}: ${team1Name} vs ${team2Name} (${team2Name} zaten bu haftada maç var)`);
            continue;
          }

          // ✅ HER ŞEY TAMAM - Maçı ekle
          newMatches.push({
            id: Date.now() + i,
            team1: team1Name,
            team2: team2Name,
            league: team1.league || team2.league || 'Bilinmiyor',
            week: week
          });
        }

        // ✅ SONUÇ RAPORU
        let resultMessage = '';
        
        if (newMatches.length > 0) {
          resultMessage += `✅ ${newMatches.length} maç başarıyla eklendi!\n\n`;
        }

        if (notFoundTeams.length > 0) {
          resultMessage += `⚠️ Sistemde Bulunamayan Takımlar:\n`;
          resultMessage += notFoundTeams.map(t => `  • ${t}`).join('\n');
          resultMessage += '\n\n';
        }

        if (skippedMatches.length > 0) {
          resultMessage += `❌ Atlanan Eşleşmeler (${skippedMatches.length}):\n`;
          resultMessage += skippedMatches.slice(0, 10).map(s => `  • ${s}`).join('\n');
          if (skippedMatches.length > 10) {
            resultMessage += `\n  ... ve ${skippedMatches.length - 10} eşleşme daha`;
          }
          resultMessage += '\n\n';
        }

        if (newMatches.length === 0) {
          alert('❌ Hiç geçerli eşleştirme bulunamadı!\n\n' + resultMessage);
          return;
        }

        // ✅ MEVCUT MAÇLARIN ÜZERİNE EKLE
        setPendingMatches([...pendingMatches, ...newMatches]);
        
        // Detaylı rapor göster
        alert(resultMessage || 'Excel yüklendi!');
        
      } catch (err) {
        setError('Excel okuma hatası: ' + err);
      }
    };

    reader.readAsArrayBuffer(file);
  } catch (err) {
    setError('Dosya yükleme hatası: ' + err);
  }
};

  // ✅ YENİ: Manuel maç ekleme
  const addManualMatch = () => {
    if (!newTeam1 || !newTeam2) {
      alert('Her iki takımı da seçin');
      return;
    }
    if (newTeam1 === newTeam2) {
      alert('Aynı takımı seçemezsiniz');
      return;
    }

    const team1 = teams.find((t: Team) => t.name === newTeam1);
    const team2 = teams.find((t: Team) => t.name === newTeam2);

    const newMatch: Match = {
      id: Date.now(),
      team1: newTeam1,
      team2: newTeam2,
      league: team1?.league || team2?.league || 'Bilinmiyor',
      week: newWeek
    };

    setPendingMatches([...pendingMatches, newMatch]);
    setNewTeam1('');
    setNewTeam2('');
    setNewWeek(1);
  };

  const deleteMatch = (id: number) => {
    setPendingMatches(pendingMatches.filter(m => m.id !== id));
  };

  const goToReview = () => {
    localStorage.setItem('pendingMatches', JSON.stringify(pendingMatches));
    setView('review-matches');
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">➕ Eşleşme Ekle</h1>
            <button onClick={() => setView('admin-menu')} className="text-gray-600 hover:text-gray-800">← Geri</button>
          </div>

          {/* ✅ YENİ: MANUEL MAÇ EKLEME */}
          <div className="mb-6 p-4 bg-green-50 rounded-lg border-2 border-green-200">
            <h3 className="font-bold mb-3 text-green-800">✍️ Manuel Maç Ekle</h3>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-3">
              <select 
                value={newTeam1} 
                onChange={(e) => setNewTeam1(e.target.value)} 
                className="px-3 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
              >
                <option value="">Takım 1 Seç</option>
                {teams.map((t: Team) => (
                  <option key={t.id} value={t.name}>{t.name} ({t.league})</option>
                ))}
              </select>
              
              <select 
                value={newTeam2} 
                onChange={(e) => setNewTeam2(e.target.value)} 
                className="px-3 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
              >
                <option value="">Takım 2 Seç</option>
                {teams.map((t: Team) => (
                  <option key={t.id} value={t.name}>{t.name} ({t.league})</option>
                ))}
              </select>

              <select 
                value={newWeek} 
                onChange={(e) => setNewWeek(parseInt(e.target.value))} 
                className="px-3 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
              >
                <option value={1}>1. Hafta</option>
                <option value={2}>2. Hafta</option>
                <option value={3}>3. Hafta</option>
                <option value={4}>4. Hafta</option>
              </select>

              <button 
                onClick={addManualMatch} 
                className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg flex items-center justify-center gap-2"
              >
                <Plus size={20} /> Ekle
              </button>
            </div>

            {/* Eklenen Maçlar */}
            {pendingMatches.length > 0 && (
              <div className="mt-4">
                <h4 className="font-semibold text-sm text-gray-700 mb-2">Eklenen Maçlar ({pendingMatches.length})</h4>
                <div className="space-y-2 max-h-40 overflow-y-auto">
                  {pendingMatches.slice(0, 3).map((match) => (
                    <div key={match.id} className="flex justify-between items-center p-2 bg-white rounded border text-sm">
                      <span><strong>{match.team1}</strong> vs <strong>{match.team2}</strong> ({match.week}. Hafta)</span>
                      <button onClick={() => deleteMatch(match.id)} className="text-red-600 hover:text-red-700">
                        <Trash2 size={16} />
                      </button>
                    </div>
                  ))}
                  {pendingMatches.length > 3 && (
                    <p className="text-xs text-gray-500 text-center">... ve {pendingMatches.length - 3} maç daha</p>
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="mb-4 text-center">
            <div className="inline-flex items-center gap-4">
              <div className="h-px bg-gray-300 w-24"></div>
              <span className="text-gray-500 font-semibold">VEYA</span>
              <div className="h-px bg-gray-300 w-24"></div>
            </div>
          </div>

          {/* EXCEL YÜKLEME */}
          <div className="mb-6 p-4 bg-blue-50 rounded-lg border-2 border-blue-200">
            <h3 className="font-bold mb-3 text-blue-800">📄 Excel ile Toplu Yükle</h3>
            
            <div className="mb-4 p-3 bg-white rounded border border-blue-300 text-sm">
              <p className="font-bold mb-1 text-blue-900">Excel Formatı:</p>
              <p className="text-blue-800">• A sütunu: Takım 1 adı</p>
              <p className="text-blue-800">• B sütunu: Takım 2 adı</p>
              <p className="text-blue-800">• C sütunu: Hafta (1-4)</p>
              <p className="text-blue-800">• İlk satır başlık olabilir (otomatik atlanır)</p>
            </div>

            {error && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">{error}</div>}

            <div className="border-2 border-dashed border-blue-300 rounded-lg p-6 text-center bg-white">
              <Upload size={48} className="mx-auto mb-3 text-blue-400" />
              <label className="cursor-pointer">
                <span className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg inline-block transition">
                  Excel Dosyası Seç
                </span>
                <input 
                  type="file" 
                  accept=".xlsx,.xls" 
                  onChange={handleFileUpload} 
                  className="hidden" 
                />
              </label>
              <p className="text-gray-500 mt-3 text-sm">Sadece .xlsx veya .xls dosyaları</p>
            </div>
          </div>

          {/* DEVAM ET BUTONU */}
          {pendingMatches.length > 0 && (
            <button 
              onClick={goToReview} 
              className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 rounded-lg flex items-center justify-center gap-2 text-lg"
            >
              <Check size={24} />
              Devam Et ({pendingMatches.length} maç)
            </button>
          )}
        </div>
      </div>
    </div>
  );
}



function TeamManagement({ setView, teams, saveTeams }: any) {
  const [showAdd, setShowAdd] = useState(false);
  const [editingTeam, setEditingTeam] = useState<Team | null>(null);
  const [newTeamName, setNewTeamName] = useState('');
  const [newTeamPassword, setNewTeamPassword] = useState('');
  const [newTeamLeague, setNewTeamLeague] = useState(LEAGUES[0]);
  const [showAvailabilityReport, setShowAvailabilityReport] = useState(false); // ✅ YENİ
  const [availabilityData, setAvailabilityData] = useState<Record<string, AvailabilitySlot[]>>({}); // ✅ YENİ

  // ✅ YENİ: Firebase'den müsaitlik verilerini çek
  useEffect(() => {
    const availRef = ref(database, 'availability');
    onValue(availRef, (snapshot) => {
      setAvailabilityData(snapshot.val() || {});
    });
  }, []);

  // ✅ YENİ: Müsaitlik raporunu hesapla
  const getAvailabilityReport = () => {
    const report: Array<{
      teamName: string;
      league: string;
      totalSlots: number;
      status: 'complete' | 'incomplete' | 'not-entered';
      issues: string[];
      weeklyStats: Array<{
        week: number;
        slots: number;
        days: number;
        offPeakDays: number;
        isValid: boolean;
      }>;
    }> = [];

    teams.forEach((team: Team) => {
      const teamAvail = availabilityData[team.name] || [];
      const totalSlots = teamAvail.length;
      const issues: string[] = [];
      const weeklyStats = [];

      // Hiç müsaitlik girilmemiş
      if (totalSlots === 0) {
        report.push({
          teamName: team.name,
          league: team.league,
          totalSlots: 0,
          status: 'not-entered',
          issues: ['Hiç müsaitlik girilmemiş'],
          weeklyStats: []
        });
        return;
      }

      // Hafta bazlı kontrol
      for (let weekNum = 1; weekNum <= 4; weekNum++) {
        const weekSlots = teamAvail.filter(s => s.week === weekNum);
        const uniqueDays = new Set(weekSlots.map(s => s.day));
        
        const offPeakDays = new Set();
        weekSlots.forEach(slot => {
          const hour = parseInt(slot.time.split(':')[0]);
          const totalMinutes = hour * 60 + parseInt(slot.time.split(':')[1]);
          if (totalMinutes < 1200 || totalMinutes >= 1440) {
            offPeakDays.add(slot.day);
          }
        });

        const isValid = weekSlots.length >= 15 && uniqueDays.size >= 4 && offPeakDays.size >= 2;

        weeklyStats.push({
          week: weekNum,
          slots: weekSlots.length,
          days: uniqueDays.size,
          offPeakDays: offPeakDays.size,
          isValid
        });

        // Hataları topla
        if (weekSlots.length < 15) {
          issues.push(`${weekNum}. Hafta: Sadece ${weekSlots.length} saat seçilmiş (minimum 15)`);
        }
        if (uniqueDays.size < 4) {
          issues.push(`${weekNum}. Hafta: Sadece ${uniqueDays.size} farklı günden seçilmiş (minimum 4)`);
        }
        if (offPeakDays.size < 2) {
          issues.push(`${weekNum}. Hafta: Sadece ${offPeakDays.size} gün off-peak seçilmiş (minimum 2)`);
        }
      }

      // Genel kontrol
      if (totalSlots < 60) {
        issues.push(`Toplam sadece ${totalSlots} saat seçilmiş (minimum 60)`);
      }

      const status = issues.length === 0 ? 'complete' : 'incomplete';

      report.push({
        teamName: team.name,
        league: team.league,
        totalSlots,
        status,
        issues,
        weeklyStats
      });
    });

    // Önce sorunlu takımlar, sonra eksiksiz olanlar
    report.sort((a, b) => {
      if (a.status === 'not-entered' && b.status !== 'not-entered') return -1;
      if (a.status !== 'not-entered' && b.status === 'not-entered') return 1;
      if (a.status === 'incomplete' && b.status === 'complete') return -1;
      if (a.status === 'complete' && b.status === 'incomplete') return 1;
      return 0;
    });

    return report;
  };

  const addTeam = () => {
    if (!newTeamName || !newTeamPassword) {
      alert('Takım adı ve şifre gerekli');
      return;
    }
    if (teams.some((t: Team) => t.name === newTeamName)) {
      alert('Bu takım adı zaten kullanılıyor');
      return;
    }
    const newTeam: Team = { id: Date.now(), name: newTeamName, password: newTeamPassword, league: newTeamLeague };
    saveTeams([...teams, newTeam]);
    setNewTeamName('');
    setNewTeamPassword('');
    setNewTeamLeague(LEAGUES[0]);
    setShowAdd(false);
  };

  const deleteTeam = (teamId: number) => {
    if (window.confirm('Bu takımı silmek istediğinizden emin misiniz?')) {
      saveTeams(teams.filter((t: Team) => t.id !== teamId));
    }
  };

  const startEdit = (team: Team) => {
    setEditingTeam({ ...team });
  };

  const saveEdit = () => {
    if (!editingTeam?.name || !editingTeam?.password || !editingTeam?.league) {
      alert('Tüm alanları doldurun');
      return;
    }
    const updated = teams.map((t: Team) => t.id === editingTeam.id ? editingTeam : t);
    saveTeams(updated);
    setEditingTeam(null);
  };

  const availabilityReport = getAvailabilityReport();
  const incompleteTeams = availabilityReport.filter(t => t.status !== 'complete');

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">👥 Takım Yönetimi</h1>
            <button onClick={() => setView('admin-menu')} className="text-gray-600 hover:text-gray-800">← Geri</button>
          </div>

          {/* ✅ YENİ: BUTONLAR */}
          <div className="mb-6 flex gap-2">
            <button 
              onClick={() => setShowAdd(!showAdd)} 
              className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg flex items-center gap-2"
            >
              <Plus size={20} /> Yeni Takım Ekle
            </button>

            <button 
              onClick={() => setShowAvailabilityReport(!showAvailabilityReport)} 
              className="bg-orange-600 hover:bg-orange-700 text-white font-semibold py-2 px-4 rounded-lg flex items-center gap-2"
            >
              <Clock size={20} /> 
              Müsaitlik Kontrolü {showAvailabilityReport ? '▲' : '▼'}
              {incompleteTeams.length > 0 && (
                <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full">
                  {incompleteTeams.length}
                </span>
              )}
            </button>
          </div>

          {/* ✅ YENİ: MÜSAİTLİK RAPORU ALANI */}
          {showAvailabilityReport && (
            <div className="mb-6 border-2 border-orange-300 rounded-lg p-4 bg-orange-50">
              <h2 className="text-xl font-bold text-orange-900 mb-4">⏰ Müsaitlik Durum Raporu</h2>
              
              {/* ÖZET İSTATİSTİKLER */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div className="bg-white rounded-lg p-4 border-2 border-green-400">
                  <div className="text-sm text-gray-600 mb-1">Eksiksiz Girdi</div>
                  <div className="text-3xl font-bold text-green-600">
                    {availabilityReport.filter(t => t.status === 'complete').length}
                  </div>
                  <div className="text-xs text-gray-500 mt-1">
                    Tüm kuralları karşılıyor
                  </div>
                </div>
                
                <div className="bg-white rounded-lg p-4 border-2 border-orange-400">
                  <div className="text-sm text-gray-600 mb-1">Eksik Girdi</div>
                  <div className="text-3xl font-bold text-orange-600">
                    {availabilityReport.filter(t => t.status === 'incomplete').length}
                  </div>
                  <div className="text-xs text-gray-500 mt-1">
                    Kuralları karşılamıyor
                  </div>
                </div>

                <div className="bg-white rounded-lg p-4 border-2 border-red-400">
                  <div className="text-sm text-gray-600 mb-1">Hiç Girmedi</div>
                  <div className="text-3xl font-bold text-red-600">
                    {availabilityReport.filter(t => t.status === 'not-entered').length}
                  </div>
                  <div className="text-xs text-gray-500 mt-1">
                    Müsaitlik girilmemiş
                  </div>
                </div>
              </div>

              {/* BAŞARI ORANI */}
              <div className="bg-white rounded-lg p-4 mb-6 border-2 border-orange-300">
                <div className="flex justify-between items-center mb-2">
                  <span className="font-semibold text-gray-700">Genel Tamamlanma Oranı:</span>
                  <span className="text-2xl font-bold text-orange-600">
                    {Math.round((availabilityReport.filter(t => t.status === 'complete').length / teams.length) * 100)}%
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-4">
                  <div 
                    className="bg-orange-600 h-4 rounded-full transition-all duration-500"
                    style={{ width: `${(availabilityReport.filter(t => t.status === 'complete').length / teams.length) * 100}%` }}
                  ></div>
                </div>
              </div>

              {/* SORUNLU TAKIMLAR */}
              {incompleteTeams.length > 0 ? (
                <div className="bg-white rounded-lg p-4 border-2 border-red-300">
                  <h3 className="font-bold text-red-900 mb-3">
                    ⚠️ Sorunlu Takımlar ({incompleteTeams.length})
                  </h3>
                  <div className="space-y-3 max-h-96 overflow-y-auto">
                    {incompleteTeams.map((team, idx) => (
                      <div 
                        key={idx} 
                        className={`p-4 rounded-lg border-2 ${
                          team.status === 'not-entered' 
                            ? 'bg-red-50 border-red-400' 
                            : 'bg-orange-50 border-orange-400'
                        }`}
                      >
                        <div className="flex justify-between items-start mb-3">
                          <div>
                            <div className="font-bold text-gray-800 text-lg">{team.teamName}</div>
                            <div className="text-sm text-gray-600">{team.league}</div>
                          </div>
                          <div className="text-right">
                            <div className={`px-3 py-1 rounded-full text-sm font-bold ${
                              team.status === 'not-entered' 
                                ? 'bg-red-500 text-white' 
                                : 'bg-orange-500 text-white'
                            }`}>
                              {team.status === 'not-entered' ? 'GİRİLMEDİ' : 'EKSİK'}
                            </div>
                            <div className="text-xs text-gray-500 mt-1">
                              {team.totalSlots} / 60 saat
                            </div>
                          </div>
                        </div>

                        {/* SORUNLAR LİSTESİ */}
                        <div className="bg-white rounded-lg p-3 border border-gray-200">
                          <div className="font-semibold text-sm text-gray-700 mb-2">Sorunlar:</div>
                          <ul className="space-y-1">
                            {team.issues.map((issue, i) => (
                              <li key={i} className="text-sm text-red-700 flex items-start gap-2">
                                <span className="text-red-500 font-bold">•</span>
                                <span>{issue}</span>
                              </li>
                            ))}
                          </ul>
                        </div>

                        {/* HAFTALIK DETAY */}
                        {team.weeklyStats.length > 0 && (
                          <div className="mt-3 grid grid-cols-4 gap-2">
                            {team.weeklyStats.map((week, i) => (
                              <div 
                                key={i} 
                                className={`p-2 rounded text-center text-xs border ${
                                  week.isValid 
                                    ? 'bg-green-100 border-green-300' 
                                    : 'bg-red-100 border-red-300'
                                }`}
                              >
                                <div className="font-bold">{week.week}. Hafta</div>
                                <div className="text-xs mt-1">
                                  <div>{week.slots}/15 saat</div>
                                  <div>{week.days}/4 gün</div>
                                  <div>{week.offPeakDays}/2 off-peak</div>
                                </div>
                                <div className="mt-1">
                                  {week.isValid ? '✅' : '❌'}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="bg-green-50 border-2 border-green-400 rounded-lg p-6 text-center">
                  <div className="text-6xl mb-3">🎉</div>
                  <div className="text-2xl font-bold text-green-800 mb-2">Mükemmel!</div>
                  <div className="text-green-700">
                    Tüm takımlar müsaitlik kurallarına uygun şekilde saat seçmiş!
                  </div>
                </div>
              )}
            </div>
          )}

          {showAdd && (
            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
              <h3 className="font-bold mb-3">Yeni Takım</h3>
              <div className="space-y-3">
                <input type="text" placeholder="Takım Adı" value={newTeamName} onChange={(e) => setNewTeamName(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" />
                <input type="text" placeholder="Şifre" value={newTeamPassword} onChange={(e) => setNewTeamPassword(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" />
                <select value={newTeamLeague} onChange={(e) => setNewTeamLeague(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none">
                  {LEAGUES.map(league => <option key={league} value={league}>{league}</option>)}
                </select>
                <div className="flex gap-2">
                  <button onClick={addTeam} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg">Kaydet</button>
                  <button onClick={() => setShowAdd(false)} className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg">İptal</button>
                </div>
              </div>
            </div>
          )}

          <div className="space-y-3">
            {teams.length === 0 ? (
              <div className="text-center py-12 text-gray-500">Henüz takım eklenmemiş</div>
            ) : (
              teams.map((team: Team) => (
                <div key={team.id} className="border border-gray-300 rounded-lg p-4">
                  {editingTeam && editingTeam.id === team.id ? (
                    <div className="space-y-3">
                      <input type="text" value={editingTeam.name} onChange={(e) => setEditingTeam({ ...editingTeam, name: e.target.value })} className="w-full px-4 py-2 border rounded-lg" />
                      <input type="text" value={editingTeam.password} onChange={(e) => setEditingTeam({ ...editingTeam, password: e.target.value })} className="w-full px-4 py-2 border rounded-lg" />
                      <select value={editingTeam.league} onChange={(e) => setEditingTeam({ ...editingTeam, league: e.target.value })} className="w-full px-4 py-2 border rounded-lg">
                        {LEAGUES.map(league => <option key={league} value={league}>{league}</option>)}
                      </select>
                      <div className="flex gap-2">
                        <button onClick={saveEdit} className="flex items-center gap-1 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">
                          <Save size={16} /> Kaydet
                        </button>
                        <button onClick={() => setEditingTeam(null)} className="flex items-center gap-1 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600">
                          <X size={16} /> İptal
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="flex justify-between items-center">
                      <div>
                        <div className="font-bold text-lg">{team.name}</div>
                        <div className="text-gray-600 text-sm">Lig: {team.league}</div>
                        <div className="text-gray-600 text-sm">Şifre: {team.password}</div>
                      </div>
                      <div className="flex gap-2">
                        <button onClick={() => startEdit(team)} className="text-blue-600 hover:text-blue-700">
                          <Edit size={20} />
                        </button>
                        <button onClick={() => deleteTeam(team.id)} className="text-red-600 hover:text-red-700">
                          <Trash2 size={20} />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function CaptainPanel({ view, setView, logout, currentTeam, fixtures, availability, saveAvailability, fixturePublished, teams, saveTeams }: any) {
  if (view === 'captain-menu') {
    return (
      <div className="min-h-screen bg-gray-100 p-4">
         <Navbar />
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-2xl font-bold text-gray-800">👤 {currentTeam.name}</h1>
              <button onClick={logout} className="flex items-center gap-2 text-red-600 hover:text-red-700">
                <LogOut size={20} /> Çıkış
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <button onClick={() => setView('captain-fixture')} className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-6 rounded-lg flex items-center justify-center gap-2 transition">
                <Calendar size={24} />
                Fikstürü Gör
              </button>
              <button onClick={() => setView('captain-availability')} className="bg-green-600 hover:bg-green-700 text-white font-semibold py-6 rounded-lg flex items-center justify-center gap-2 transition">
                <Clock size={24} />
                Müsait Saat Seç
              </button>
                <button onClick={() => setView('change-password')} className="bg-purple-600 hover:bg-purple-700 text-white font-semibold py-6 rounded-lg flex items-center justify-center gap-2 transition">
                <Key size={24} />
                Şifre Değiştir
                </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (view === 'captain-fixture') {
    return (
      <>
     <Navbar />
     <CaptainViewFixture setView={setView} currentTeam={currentTeam} fixtures={fixtures} fixturePublished={fixturePublished} />;
     </>);
  }

  if (view === 'captain-availability') {
    return (
      <>
     <Navbar />
     <CaptainAvailability setView={setView} currentTeam={currentTeam} availability={availability} saveAvailability={saveAvailability} />;
     </>);
  }

  if (view === 'change-password') {
    return (
      <>
     <Navbar />
    <ChangePassword setView={setView} currentTeam={currentTeam} teams={teams} saveTeams={saveTeams} />;
    </>);
  }
  return null;
}

function CaptainViewFixture({ setView, currentTeam, fixtures, fixturePublished }: any) {
  const myMatch = fixtures.find((f: Match) => f.team1 === currentTeam.name || f.team2 === currentTeam.name);

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">📅 Fikstür</h1>
            <button onClick={() => setView('captain-menu')} className="text-gray-600 hover:text-gray-800">← Geri</button>
          </div>

          {!fixturePublished ? (
            <div className="text-center py-12">
              <div className="text-6xl mb-4">⏳</div>
              <div className="text-xl font-semibold text-gray-700">Fikstür henüz yayınlanmadı</div>
              <div className="text-gray-600 mt-2">Lütfen daha sonra tekrar kontrol edin</div>
            </div>
          ) : !myMatch ? (
            <div className="text-center py-12">
              <div className="text-6xl mb-4">❌</div>
              <div className="text-xl font-semibold text-gray-700">Bu hafta maçınız yok</div>
            </div>
          ) : (
            <div className="bg-gradient-to-r from-blue-500 to-green-500 rounded-lg p-6 text-white">
              <div className="text-center mb-4">
                <div className="text-3xl font-bold mb-2">
                  {myMatch.team1} <span className="text-2xl">VS</span> {myMatch.team2}
                </div>
              </div>
              <div className="bg-white bg-opacity-20 rounded-lg p-4 space-y-2">
                <div className="flex items-center gap-2 text-lg">
                  <Calendar size={20} />
                  <span className="font-semibold">{myMatch.day}</span>
                </div>
                <div className="flex items-center gap-2 text-lg">
                  <Clock size={20} />
                  <span className="font-semibold">{myMatch.time}</span>
                </div>
                <div className="flex items-center gap-2 text-lg">
                  <Users size={20} />
                  <span className="font-semibold">{myMatch.field}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function CaptainAvailability({ setView, currentTeam, availability, saveAvailability }: any) {
  const [currentSeason, setCurrentSeason] = useState<Season | null>(null);
  const [selectedWeek, setSelectedWeek] = useState(1);
  const [selected, setSelected] = useState<AvailabilitySlot[]>(() => {
    const saved = availability[currentTeam.name] || [];
    return saved.filter((slot: AvailabilitySlot) => slot.week >= 1 && slot.week <= 4);
  });
  const [error, setError] = useState('');

  useEffect(() => {
    const seasonRef = ref(database, 'current_season');
    onValue(seasonRef, (snapshot) => {
      setCurrentSeason(snapshot.val());
    });
  }, []);

  if (!currentSeason) {
    return (
      <div className="min-h-screen bg-gray-100 p-4">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-2xl font-bold text-gray-800">⚠️ Aktif Dönem Yok</h1>
              <button onClick={() => setView('captain-menu')} className="text-gray-600 hover:text-gray-800">← Geri</button>
            </div>
            <p className="text-gray-600">Admin henüz yeni dönem başlatmamış. Lütfen daha sonra tekrar deneyin.</p>
          </div>
        </div>
      </div>
    );
  }

  const weeks = getWeekRanges(currentSeason.startDate);

  const toggleSlot = (day: string, time: string, field: string, week: number) => {
    const key = `${day}-${time}-${field}-${week}`;
    const exists = selected.some(s => `${s.day}-${s.time}-${s.field}-${s.week}` === key);
    if (exists) {
      setSelected(selected.filter(s => `${s.day}-${s.time}-${s.field}-${s.week}` !== key));
    } else {
      setSelected([...selected, { day, time, field, week }]);
    }
  };

  const isSelected = (day: string, time: string, field: string, week: number) => {
    return selected.some(s => s.day === day && s.time === time && s.field === field && s.week === week);
  };

  const handleSave = () => {
    setError('');
    
    const weekChecks = [1, 2, 3, 4].map(weekNum => {
      const weekSlots = selected.filter(s => s.week === weekNum);
      
      const hasEnoughSlots = weekSlots.length >= 20;
      
      const uniqueDays = new Set(weekSlots.map(slot => slot.day));
      const hasEnoughDays = uniqueDays.size >= 4;
      
      // 🆕 YENİ KURAL: Hafta içi SADECE 19:15 VEYA 00:15
      const weekdayOffPeakDays = new Set();
      const weekdays = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma'];
      weekSlots.forEach(slot => {
        if (weekdays.includes(slot.day)) {
          // Sadece 19:15 veya 00:15 saatleri geçerli
          if (slot.time === '19:15' || slot.time === '00:15') {
            weekdayOffPeakDays.add(slot.day);
          }
        }
      });
      const hasEnoughWeekdayOffPeak = weekdayOffPeakDays.size >= 2;
      
      return {
        week: weekNum,
        slotCount: weekSlots.length,
        uniqueDayCount: uniqueDays.size,
        weekdayOffPeakDayCount: weekdayOffPeakDays.size,
        hasEnoughSlots,
        hasEnoughDays,
        hasEnoughWeekdayOffPeak,
        isValid: hasEnoughSlots && hasEnoughDays && hasEnoughWeekdayOffPeak
      };
    });
    
    const invalidWeeks = weekChecks.filter(w => !w.isValid);
    
    if (invalidWeeks.length > 0) {
      const errorMessages = invalidWeeks.map(w => {
        const issues = [];
        if (!w.hasEnoughSlots) {
          issues.push(`en az 20 saat seçmelisiniz (şu an: ${w.slotCount})`);
        }
        if (!w.hasEnoughDays) {
          issues.push(`en az 4 farklı günden saat seçmelisiniz (şu an: ${w.uniqueDayCount} gün)`);
        }
        if (!w.hasEnoughWeekdayOffPeak) {
          issues.push(`hafta içi en az 2 gün için 19:15 veya 00:15 saati seçmelisiniz (şu an: ${w.weekdayOffPeakDayCount} gün)`);
        }
        return `${w.week}. Hafta: ${issues.join(' ve ')}`;
      });
      
      setError('❌ Eksik müsaitlik:\n' + errorMessages.join('\n'));
      return;
    }
    
    if (selected.length < 80) {
      setError('En az 80 saat seçmelisiniz (4 hafta x 20 saat). Şu an: ' + selected.length);
      return;
    }
    
    const newAvail = { ...availability, [currentTeam.name]: selected };
    saveAvailability(newAvail);
    alert('Müsaitlik kaydedildi!');
    setView('captain-menu');
  };

  const currentWeekSlots = selected.filter(s => s.week === selectedWeek);

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">⏰ Müsait Saat Seç (4 Haftalık)</h1>
            <button onClick={() => setView('captain-menu')} className="text-gray-600 hover:text-gray-800">← Geri</button>
          </div>

          <div className="mb-4 bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded">
            <p className="font-bold">Kurallar:</p>
            <p>• Toplam en az 80 saat seçmelisiniz (4 hafta x 20 saat)</p>
            <p>• Her hafta en az 4 farklı günden saat seçmelisiniz</p>
            <p>• Hafta içi (Pazartesi-Cuma) her hafta en az 2 gün için 19:15 veya 00:15 saati seçmelisiniz</p>
          </div>

          <div className="mb-6 flex gap-2 flex-wrap">
            {weeks.map(week => (
              <button 
                key={week.weekNumber} 
                onClick={() => setSelectedWeek(week.weekNumber)} 
                className={`px-4 py-2 rounded-lg font-semibold transition ${selectedWeek === week.weekNumber ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
              >
                {week.weekNumber}. Hafta<br/>
                <span className="text-xs">{week.startDate} - {week.endDate}</span>
              </button>
            ))}
          </div>

          <div className="mb-4 flex gap-2">
            <button 
              onClick={() => {
                const allSlotsForWeek: AvailabilitySlot[] = [];
                DAYS.forEach(day => {
                  TIME_SLOTS[day].forEach(slot => {
                    allSlotsForWeek.push({
                      day,
                      time: slot.time,
                      field: slot.field,
                      week: selectedWeek
                    });
                  });
                });
                
                const otherWeeks = selected.filter(s => s.week !== selectedWeek);
                setSelected([...otherWeeks, ...allSlotsForWeek]);
              }}
              className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg transition"
            >
              ✅ {selectedWeek}. Haftanın Tümünü Seç
            </button>
            
            <button 
              onClick={() => {
                const otherWeeks = selected.filter(s => s.week !== selectedWeek);
                setSelected(otherWeeks);
              }}
              className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-lg transition"
            >
              ❌ {selectedWeek}. Haftanın Tümünü Kaldır
            </button>
          </div>

          <div className="mb-4">
            <div className="text-lg font-semibold mb-2">
              Toplam Seçilen: <span className={selected.length >= 80 ? 'text-green-600' : 'text-red-600'}>{selected.length}/80</span>
              {' | '}
              Bu Hafta: <span className="text-blue-600">{currentWeekSlots.length}</span>
            </div>
            
            <div className="grid grid-cols-4 gap-2">
              {[1, 2, 3, 4].map(weekNum => {
                const weekSlots = selected.filter(s => s.week === weekNum);
                
                const uniqueDays = new Set(weekSlots.map(s => s.day));
                
                // 🆕 YENİ HESAPLAMA: Hafta içi SADECE 19:15 VEYA 00:15
                const weekdayOffPeakDays = new Set();
                const weekdays = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma'];
                weekSlots.forEach(slot => {
                  if (weekdays.includes(slot.day)) {
                    if (slot.time === '19:15' || slot.time === '00:15') {
                      weekdayOffPeakDays.add(slot.day);
                    }
                  }
                });
                
                const isComplete = weekSlots.length >= 20 && uniqueDays.size >= 4 && weekdayOffPeakDays.size >= 2;
                
                return (
                  <div 
                    key={weekNum} 
                    className={`p-2 rounded border ${isComplete ? 'bg-green-100 border-green-400' : 'bg-red-100 border-red-400'}`}
                  >
                    <div className="text-sm font-semibold">{weekNum}. Hafta</div>
                    <div className="text-xs">Saat: {weekSlots.length}/20</div>
                    <div className="text-xs">Gün: {uniqueDays.size}/4</div>
                    <div className="text-xs">Off-peak: {weekdayOffPeakDays.size}/2 gün</div>
                    <div className="text-xs font-bold">{isComplete ? '✅ Tamam' : '❌ Eksik'}</div>
                  </div>
                );
              })}
            </div>
          </div>

          {error && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 whitespace-pre-line">{error}</div>}

          <div className="space-y-6 mb-6">
            {DAYS.map(day => (
              <div key={day} className="border border-gray-300 rounded-lg p-4">
                <h3 className="font-bold text-lg mb-3">{day}</h3>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2">
                  {TIME_SLOTS[day].map(slot => {
                    const selectedSlot = isSelected(day, slot.time, slot.field, selectedWeek);
                    return (
                      <button 
                        key={`${slot.time}-${slot.field}`} 
                        onClick={() => toggleSlot(day, slot.time, slot.field, selectedWeek)} 
                        className={`px-3 py-2 rounded-lg text-sm font-medium transition ${selectedSlot ? 'bg-green-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                      >
                        {slot.time}<br/><span className="text-xs">{slot.field}</span>
                      </button>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>

          <button onClick={handleSave} className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-lg">
            Müsaitliği Kaydet
          </button>
        </div>
      </div>
    </div>
  );
}
function ChangePassword({ setView, currentTeam, teams, saveTeams }: any) {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const handleChangePassword = () => {
    setError('');
    
    if (!oldPassword || !newPassword || !confirmPassword) {
      setError('Tüm alanları doldurun');
      return;
    }
    
    if (oldPassword !== currentTeam.password) {
      setError('Eski şifre hatalı');
      return;
    }
    
    if (newPassword.length < 4) {
      setError('Yeni şifre en az 4 karakter olmalı');
      return;
    }
    
    if (newPassword !== confirmPassword) {
      setError('Yeni şifreler eşleşmiyor');
      return;
    }
    
    const updatedTeams = teams.map((t: Team) => 
      t.id === currentTeam.id ? { ...t, password: newPassword } : t
    );
    saveTeams(updatedTeams);
    alert('Şifre başarıyla değiştirildi!');
    setView('captain-menu');
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-md mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">🔑 Şifre Değiştir</h1>
            <button onClick={() => setView('captain-menu')} className="text-gray-600 hover:text-gray-800">← Geri</button>
          </div>

          {error && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">{error}</div>}

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Eski Şifre</label>
              <input 
                type="password" 
                value={oldPassword} 
                onChange={(e) => setOldPassword(e.target.value)} 
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" 
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Yeni Şifre</label>
              <input 
                type="password" 
                value={newPassword} 
                onChange={(e) => setNewPassword(e.target.value)} 
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" 
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Yeni Şifre (Tekrar)</label>
              <input 
                type="password" 
                value={confirmPassword} 
                onChange={(e) => setConfirmPassword(e.target.value)} 
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" 
              />
            </div>
            <button 
              onClick={handleChangePassword} 
              className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 rounded-lg transition"
            >
              Şifreyi Değiştir
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
function SeasonManagement({ setView }: any) {
  const [startDate, setStartDate] = useState('');
  const [currentSeason, setCurrentSeason] = useState<Season | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const seasonRef = ref(database, 'current_season');
    onValue(seasonRef, (snapshot) => {
      setCurrentSeason(snapshot.val());
      setLoading(false);
    });
  }, []);

  const handleCreateSeason = async () => {
    if (!startDate) {
      alert('Başlangıç tarihi seçin');
      return;
    }

    const start = new Date(startDate);
    const end = new Date(start);
    end.setDate(start.getDate() + 27); // 4 hafta = 28 gün

    const newSeason: Season = {
      id: Date.now(),
      startDate: startDate,
      endDate: end.toISOString().split('T')[0],
      isActive: true,
      createdAt: Date.now()
    };

    if (window.confirm(`Yeni dönem başlatılacak:\n${startDate} - ${newSeason.endDate}\n\nEski müsaitlikler silinecek. Emin misiniz?`)) {
      try {
        // Yeni dönemi kaydet
        await set(ref(database, 'current_season'), newSeason);
        
        // Eski müsaitleri temizle
        await set(ref(database, 'availability'), {});
        
        // Eski fikstürü temizle
        await set(ref(database, 'fixtures'), []);
        await set(ref(database, 'fixture_published'), false);
        
        alert('Yeni dönem başlatıldı!');
        setView('admin-menu');
      } catch (error) {
        alert('Hata: ' + error);
      }
    }
  };

  if (loading) {
    return <div className="min-h-screen bg-gray-100 flex items-center justify-center">Yükleniyor...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">📅 Dönem Yönetimi</h1>
            <button onClick={() => setView('admin-menu')} className="text-gray-600 hover:text-gray-800">← Geri</button>
          </div>

          {currentSeason && (
            <div className="mb-6 p-4 bg-green-100 border border-green-400 rounded-lg">
              <h3 className="font-bold text-green-800 mb-2">Aktif Dönem:</h3>
              <p className="text-green-700">
                {new Date(currentSeason.startDate).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}
                {' - '}
                {new Date(currentSeason.endDate).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}
              </p>
            </div>
          )}

          <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded mb-6">
            <p className="font-bold mb-2">⚠️ Dikkat!</p>
            <p>Yeni dönem başlatıldığında:</p>
            <ul className="list-disc ml-6 mt-2">
              <li>Tüm müsaitlikler silinecek</li>
              <li>Eski fikstür temizlenecek</li>
              <li>Kaptanlar yeniden müsaitlik girecek</li>
            </ul>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Yeni Dönem Başlangıç Tarihi (Pazartesi seçin):
              </label>
              <input 
                type="date" 
                value={startDate} 
                onChange={(e) => setStartDate(e.target.value)} 
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              />
            </div>

            {startDate && (
              <div className="p-4 bg-blue-100 border border-blue-400 rounded-lg">
                <p className="text-blue-800 font-semibold">Seçilen Dönem:</p>
                <p className="text-blue-700">
                  {new Date(startDate).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}
                  {' - '}
                  {new Date(new Date(startDate).getTime() + 27 * 24 * 60 * 60 * 1000).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}
                </p>
              </div>
            )}

            <button 
              onClick={handleCreateSeason} 
              disabled={!startDate}
              className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white font-semibold py-3 rounded-lg transition"
            >
              Yeni Dönem Başlat
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
function ReviewMatches({ setView, teams, availability, saveFixtures }: any) {
  const [matches, setMatches] = useState<Match[]>(() => {
    const saved = localStorage.getItem('pendingMatches');
    return saved ? JSON.parse(saved) : [];
  });
  
  const [newTeam1, setNewTeam1] = useState('');
  const [newTeam2, setNewTeam2] = useState('');
  const [newWeek, setNewWeek] = useState(1);

  const addManualMatch = () => {
    if (!newTeam1 || !newTeam2) {
      alert('Her iki takımı da seçin');
      return;
    }
    if (newTeam1 === newTeam2) {
      alert('Aynı takımı seçemezsiniz');
      return;
    }

    const team1 = teams.find((t: Team) => t.name === newTeam1);
    const team2 = teams.find((t: Team) => t.name === newTeam2);

    const newMatch: Match = {
      id: Date.now(),
      team1: newTeam1,
      team2: newTeam2,
      league: team1?.league || team2?.league || 'Bilinmiyor',
      week: newWeek
    };

    setMatches([...matches, newMatch]);
    setNewTeam1('');
    setNewTeam2('');
    setNewWeek(1);
  };

  const deleteMatch = (id: number) => {
    setMatches(matches.filter(m => m.id !== id));
  };

  const handleCreateFixture = () => {
    if (matches.length === 0) {
      alert('Hiç maç yok!');
      return;
    }

    if (window.confirm(`${matches.length} maç için fikstür hazırlanacak. Emin misiniz?`)) {
      try {
        const fixtureMatches = createFixture(matches, availability, teams);
        saveFixtures(fixtureMatches);
        localStorage.removeItem('pendingMatches');
        alert('Fikstür hazırlandı!');
        setView('view-fixture');
      } catch (error) {
        console.error('Fikstür hazırlama hatası:', error);
        alert('Hata: ' + error);
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">⚽ Maçları İncele ve Düzenle</h1>
            <button onClick={() => setView('admin-menu')} className="text-gray-600 hover:text-gray-800">← Geri</button>
          </div>

          {/* MANUEL MAÇ EKLEME */}
          <div className="mb-6 p-4 bg-green-50 rounded-lg border-2 border-green-200">
            <h3 className="font-bold mb-3 text-green-800">➕ Manuel Maç Ekle</h3>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
              <select 
                value={newTeam1} 
                onChange={(e) => setNewTeam1(e.target.value)} 
                className="px-3 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
              >
                <option value="">Takım 1 Seç</option>
                {teams.map((t: Team) => (
                  <option key={t.id} value={t.name}>{t.name} ({t.league})</option>
                ))}
              </select>
              
              <select 
                value={newTeam2} 
                onChange={(e) => setNewTeam2(e.target.value)} 
                className="px-3 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
              >
                <option value="">Takım 2 Seç</option>
                {teams.map((t: Team) => (
                  <option key={t.id} value={t.name}>{t.name} ({t.league})</option>
                ))}
              </select>

              <select 
                value={newWeek} 
                onChange={(e) => setNewWeek(parseInt(e.target.value))} 
                className="px-3 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
              >
                <option value={1}>1. Hafta</option>
                <option value={2}>2. Hafta</option>
                <option value={3}>3. Hafta</option>
                <option value={4}>4. Hafta</option>
              </select>

              <button 
                onClick={addManualMatch} 
                className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg flex items-center justify-center gap-2"
              >
                <Plus size={20} /> Ekle
              </button>
            </div>
          </div>

          {/* MAÇ LİSTESİ */}
          <div className="mb-6">
            <h3 className="font-bold mb-3 text-gray-700">📋 Toplam {matches.length} Maç</h3>
            
            {matches.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                Henüz maç eklenmedi
              </div>
            ) : (
              [1, 2, 3, 4].map(weekNum => {
                const weekMatches = matches.filter(m => m.week === weekNum);
                if (weekMatches.length === 0) return null;
                
                return (
                  <div key={weekNum} className="mb-4">
                    <div className="bg-blue-100 px-4 py-2 rounded-t-lg font-bold text-blue-800">
                      {weekNum}. Hafta ({weekMatches.length} maç)
                    </div>
                    <div className="border border-blue-200 rounded-b-lg p-3 space-y-2">
                      {weekMatches.map((match) => (
                        <div key={match.id} className="flex justify-between items-center p-3 bg-gray-50 rounded hover:bg-gray-100 transition">
                          <div>
                            <span className="font-semibold">{match.team1}</span>
                            {' vs '}
                            <span className="font-semibold">{match.team2}</span>
                            <span className="text-sm text-gray-600 ml-2">({match.league})</span>
                          </div>
                          <button 
                            onClick={() => deleteMatch(match.id)} 
                            className="text-red-600 hover:text-red-700"
                          >
                            <Trash2 size={20} />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })
            )}
          </div>

          {/* BUTONLAR - TEK YER */}
          {matches.length > 0 && (
            <div className="space-y-3">
              <button 
                onClick={async () => {
                  try {
                    const XLSX = await import('xlsx');
                    
                    const excelData = matches.map(match => ({
                      'Takım 1': match.team1,
                      'Takım 2': match.team2,
                      'Hafta': match.week
                    }));

                    const ws = XLSX.utils.json_to_sheet(excelData);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, 'Maçlar');
                    
                    const fileName = `Maclar_${new Date().toISOString().split('T')[0]}.xlsx`;
                    XLSX.writeFile(wb, fileName);
                    
                    alert('Excel dosyası indirildi!');
                  } catch (err) {
                    alert('Excel indirme hatası: ' + err);
                  }
                }}
                className="w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 rounded-lg text-lg flex items-center justify-center gap-2"
              >
                <Download size={24} />
                Excel'e Aktar ({matches.length} maç)
              </button>

              <button 
                onClick={handleCreateFixture} 
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 rounded-lg text-lg flex items-center justify-center gap-2"
              >
                <Calendar size={24} />
                Fikstür Hazırla ({matches.length} maç)
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
function AdminViewAvailability({ setView, teams, availability }: any) {
  const [selectedTeam, setSelectedTeam] = useState<string>('');
  const [selectedWeek, setSelectedWeek] = useState(1);

  const teamAvailability = selectedTeam ? (availability[selectedTeam] || []) : [];
  const weekSlots = teamAvailability.filter((slot: AvailabilitySlot) => slot.week === selectedWeek);

  // Hafta bazlı istatistikler
  const getWeekStats = (teamName: string, weekNum: number) => {
    const slots = (availability[teamName] || []).filter((s: AvailabilitySlot) => s.week === weekNum);
    const uniqueDays = new Set(slots.map((s: AvailabilitySlot) => s.day));
    
    const offPeakDays = new Set();
    slots.forEach((slot: AvailabilitySlot) => {
      const hour = parseInt(slot.time.split(':')[0]);
      const totalMinutes = hour * 60 + parseInt(slot.time.split(':')[1]);
      if (totalMinutes < 1200 || totalMinutes >= 1440) {
        offPeakDays.add(slot.day);
      }
    });
    
    return {
      total: slots.length,
      days: uniqueDays.size,
      offPeak: offPeakDays.size,
      isComplete: slots.length >= 15 && uniqueDays.size >= 4 && offPeakDays.size >= 2
    };
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">⏰ Müsaitleri Gör</h1>
            <button onClick={() => setView('admin-menu')} className="text-gray-600 hover:text-gray-800">← Geri</button>
          </div>

          <div className="mb-6 space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Takım Seç:</label>
              <select 
                value={selectedTeam} 
                onChange={(e) => setSelectedTeam(e.target.value)} 
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              >
                <option value="">Takım Seçin</option>
                {teams.map((team: Team) => {
                  const totalSlots = (availability[team.name] || []).length;
                  return (
                    <option key={team.id} value={team.name}>
                      {team.name} ({team.league}) - {totalSlots} saat
                    </option>
                  );
                })}
              </select>
            </div>

            {selectedTeam && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Hafta Seç:</label>
                <div className="flex gap-2">
                  {[1, 2, 3, 4].map(week => (
                    <button 
                      key={week} 
                      onClick={() => setSelectedWeek(week)} 
                      className={`px-4 py-2 rounded-lg font-semibold transition ${selectedWeek === week ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                    >
                      {week}. Hafta
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          {selectedTeam && (
            <>
              {/* Haftalık İstatistikler */}
              <div className="mb-6 grid grid-cols-4 gap-2">
                {[1, 2, 3, 4].map(weekNum => {
                  const stats = getWeekStats(selectedTeam, weekNum);
                  return (
                    <div 
                      key={weekNum} 
                      className={`p-3 rounded border ${stats.isComplete ? 'bg-green-100 border-green-400' : 'bg-red-100 border-red-400'}`}
                    >
                      <div className="text-sm font-semibold">{weekNum}. Hafta</div>
                      <div className="text-xs">Saat: {stats.total}/15</div>
                      <div className="text-xs">Gün: {stats.days}/4</div>
                      <div className="text-xs">Off-peak: {stats.offPeak}/2</div>
                      <div className="text-xs font-bold">{stats.isComplete ? '✅ Tamam' : '❌ Eksik'}</div>
                    </div>
                  );
                })}
              </div>

              {/* Müsait Saatler */}
              {weekSlots.length === 0 ? (
                <div className="text-center py-12 text-gray-500">
                  {selectedTeam} - {selectedWeek}. hafta için müsaitlik girilmemiş
                </div>
              ) : (
                <div className="space-y-4">
                  <h3 className="font-bold text-lg">
                    {selectedWeek}. Hafta Müsait Saatler ({weekSlots.length} saat)
                  </h3>
                  
                  {DAYS.map(day => {
                    const daySlots = weekSlots.filter((s: AvailabilitySlot) => s.day === day);
                    if (daySlots.length === 0) return null;
                    
                    return (
                      <div key={day} className="border border-gray-300 rounded-lg p-4">
                        <h4 className="font-bold mb-2">{day} ({daySlots.length} saat)</h4>
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2">
                          {daySlots.map((slot: AvailabilitySlot, idx: number) => {
                            const hour = parseInt(slot.time.split(':')[0]);
                            const isOffPeak = hour < 20 || hour >= 24;
                            return (
                              <div 
                                key={idx} 
                                className={`px-3 py-2 rounded-lg text-sm font-medium text-center ${
                                  isOffPeak 
                                    ? 'bg-yellow-100 border border-yellow-400 text-yellow-800' 
                                    : 'bg-green-100 border border-green-400 text-green-800'
                                }`}
                              >
                                {slot.time}<br/>
                                <span className="text-xs">{slot.field}</span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          )}

          {!selectedTeam && (
            <div className="text-center py-12 text-gray-500">
              Yukarıdan bir takım seçin
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
function SearchAvailability({ setView, teams, availability }: any) {
  const [searchWeek, setSearchWeek] = useState(1);
  const [searchLeague, setSearchLeague] = useState(LEAGUES[0]);
  const [searchStartDay, setSearchStartDay] = useState('Pazartesi');
  const [searchStartTime, setSearchStartTime] = useState('19:00');
  const [searchEndDay, setSearchEndDay] = useState('Pazar');
  const [searchEndTime, setSearchEndTime] = useState('23:59');
  const [searchResults, setSearchResults] = useState<Array<{team: string, availableSlots: number, slots: AvailabilitySlot[]}>>([]);

  const handleSearch = () => {
    const dayOrder = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'];
    const startDayIndex = dayOrder.indexOf(searchStartDay);
    const endDayIndex = dayOrder.indexOf(searchEndDay);

    if (startDayIndex === -1 || endDayIndex === -1) {
      alert('Geçersiz gün seçimi!');
      return;
    }

    let searchDays: string[] = [];
    if (startDayIndex <= endDayIndex) {
      searchDays = dayOrder.slice(startDayIndex, endDayIndex + 1);
    } else {
      searchDays = [...dayOrder.slice(startDayIndex), ...dayOrder.slice(0, endDayIndex + 1)];
    }

    const [startHour, startMin] = searchStartTime.split(':').map(Number);
    const [endHour, endMin] = searchEndTime.split(':').map(Number);
    const startMinutes = startHour * 60 + startMin;
    const endMinutes = endHour * 60 + endMin;

    const leagueTeams = teams.filter((t: Team) => t.league === searchLeague);

    const results: Array<{team: string, availableSlots: number, slots: AvailabilitySlot[]}> = [];

    for (const team of leagueTeams) {
      const teamAvail = (availability[team.name] || []).filter((s: AvailabilitySlot) => s.week === searchWeek);
      
      const matchingSlots = teamAvail.filter((slot: AvailabilitySlot) => {
        if (!searchDays.includes(slot.day)) return false;

        const [slotHour, slotMin] = slot.time.split(':').map(Number);
        const slotMinutes = slotHour * 60 + slotMin;

        return slotMinutes >= startMinutes && slotMinutes <= endMinutes;
      });

      if (matchingSlots.length > 0) {
        results.push({
          team: team.name,
          availableSlots: matchingSlots.length,
          slots: matchingSlots
        });
      }
    }

    results.sort((a, b) => b.availableSlots - a.availableSlots);

    setSearchResults(results);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">🔍 Müsaitlik Arama</h1>
            <button onClick={() => setView('admin-menu')} className="text-gray-600 hover:text-gray-800">← Geri</button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Hafta:</label>
              <select 
                value={searchWeek} 
                onChange={(e) => setSearchWeek(parseInt(e.target.value))}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 outline-none"
              >
                <option value={1}>1. Hafta</option>
                <option value={2}>2. Hafta</option>
                <option value={3}>3. Hafta</option>
                <option value={4}>4. Hafta</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Lig:</label>
              <select 
                value={searchLeague} 
                onChange={(e) => setSearchLeague(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 outline-none"
              >
                {LEAGUES.map(league => <option key={league} value={league}>{league}</option>)}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Başlangıç Günü:</label>
              <select 
                value={searchStartDay} 
                onChange={(e) => setSearchStartDay(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 outline-none"
              >
                {DAYS.map(day => <option key={day} value={day}>{day}</option>)}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Başlangıç Saati:</label>
              <input 
                type="time" 
                value={searchStartTime} 
                onChange={(e) => setSearchStartTime(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 outline-none"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Bitiş Günü:</label>
              <select 
                value={searchEndDay} 
                onChange={(e) => setSearchEndDay(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 outline-none"
              >
                {DAYS.map(day => <option key={day} value={day}>{day}</option>)}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Bitiş Saati:</label>
              <input 
                type="time" 
                value={searchEndTime} 
                onChange={(e) => setSearchEndTime(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 outline-none"
              />
            </div>
          </div>

          <button 
            onClick={handleSearch}
            className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 rounded-lg mb-4"
          >
            🔍 Ara
          </button>

          {searchResults.length > 0 && (
            <div className="bg-white rounded-lg p-4 border-2 border-purple-300">
              <h3 className="font-bold text-purple-900 mb-3">
                Sonuçlar ({searchResults.length} takım bulundu)
              </h3>
              <div className="space-y-3 max-h-96 overflow-y-auto">
                {searchResults.map((result, idx) => (
                  <div key={idx} className="p-3 bg-purple-50 rounded-lg border border-purple-200">
                    <div className="flex justify-between items-center mb-2">
                      <span className="font-bold text-gray-800">{result.team}</span>
                      <span className="bg-purple-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                        {result.availableSlots} müsait saat
                      </span>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                      {result.slots.map((slot, i) => (
                        <div key={i} className="text-xs bg-white px-2 py-1 rounded border border-purple-200">
                          {slot.day} {slot.time} - {slot.field}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {searchResults.length === 0 && searchStartTime && (
            <div className="bg-white rounded-lg p-4 border-2 border-gray-300 text-center text-gray-500">
              Belirtilen kriterlerde müsait takım bulunamadı
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default App;